import { LocaleMessageObject } from 'vue-i18n';

const ru: LocaleMessageObject = {
    message: {
        one: "Тестовое сообщение"
    },
    shared: {
        button: {
            add: "Добавить",
            "add-new": "Добавить новый",
            archive: "Архивировать",
            cancel: "Отмена",
            close: "Закрыть",
            create: "Создать",
            delete: "Удалить",
            edit: "Редактировать",
            export: "Экспорт",
            import: "Импорт",
            restore: "Восстановить",
            save: "Сохранить",
            upload: "Загрузить",
            "upload-file": "Загрузить файл",
            update: "Обновить",
            next: "Далее",
            back: "Назад",
            done: "Готово",
            complete: "Завершить",
            "abandon-changes": "Отменить изменения",
            "download-template": "Скачать шаблон"
        },
        label: {
            crew: "Бригада",
            filter: "Фильтр",
            from: "от",
            leave: "Отпуск",
            "major-service": "Капитальное обслуживание",
            "minor-service": "Малое обслуживание",
            name: "Название",
            overtime: "Сверхурочные",
            role: "Роль",
            service: "Обслуживание",
            unserviceable: "Неисправен",
            "weekly-service": "Еженедельное обслуживание",
            action: "Действие",
            comments: "Комментарии",
            description: "Описание",
            "not-saved": "Не сохранено"
        },
        message: {
            "no-connection": "Нет соединения",
            "shift-planning-not-started": "Планирование этой смены не начато",
            "week-planning-not-started": "Планирование этой недели не начато",
            "select-a": "Выберите {term}",
            "error-saving": "Произошла ошибка при сохранении"
        },
        concept: {
            shift: "Смена",
            cycle: "Цикл",
            task: "Задача"
        },
        heading: {
            "add-term": "Добавить {term}",
            "create-term": "Создать {term}",
            "create-term-2": "Создать {term2} {term1}",
            "edit-term": "Редактировать {term}",
            "select-term": "Выбрать {term}",
            "term-details": "Детали {term}",
            "update-term-status": "Обновить статус {term}",
            "update-term-status-detail": "Обновить статус {term} - {detail}",
            "update-term-2": "Обновить {term1} - {term2}",
            "availability-for": "Доступность для {name}"
        },
        validation: {
            "must-not-match-existing-name": "Не должно совпадать с существующим названием.",
            "must-not-match-existing-code": "Не должно совпадать с существующим кодом.",
            "must-not-match-existing-short-name": "Не должно совпадать с существующим кратким названием.",
            "must-be-unique": "Должно быть уникальным",
            "maximum-1-decimal-point": "Максимум 1 знак после запятой",
            "not-negative": "Не отрицательное"
        }
    },
    equipment: {
        "archived-term": "Архивированный {term}",
        "mark-as-serviceable": "Отметить как исправный",
        "mark-as-unserviceable": "Отметить как неисправный",
        "show-conflicts": "Показать конфликты"
    },
    "equipment-availability-dialog": {
        heading: "Доступность оборудования"
    },
    actuals: {
        "error-saving-please-try-again": "Произошла ошибка при сохранении: {errors}. Пожалуйста, попробуйте снова.",
        "end-date": "Дата окончания",
        "export-data-by-date-range": "Экспорт данных по диапазону дат",
        "export-data-for-current-shift-not-implemented": "Экспорт данных для текущей смены (не реализовано)",
        "start-date": "Дата начала",
        "plod-entry": "Запись выработки",
        "key-physicals": "Ключевые физические показатели",
        inspections: "Инспекции",
        download: "Скачать",
        "read-only": "Только для чтения",
        editing: "Редактирование",
        "clear-data": "Очистить данные",
        "export-to-csv": "Экспорт в CSV",
        "enter-edit-mode": "Войти в режим редактирования",
        "save-and-exit": "Сохранить и выйти",
        "actuals-entry": "Ввод фактических данных",
        "confirm-clear-data": "Вы уверены, что хотите очистить все фактические данные этой смены? Это навсегда удалит все данные записи выработки, ключевых физических показателей и простоев оборудования.",
        "this-action-cannot-be-undone": "Это действие нельзя отменить.",
        "successfully-cleared-data": "Все данные смены успешно очищены.",
        "error-clearing-data": "Ошибка при очистке данных смены."
    },
    "actuals-definition-groups": {
        "assigned-actuals-definitions": "Назначенные определения фактических данных",
        "actuals-definition-groups": "Группы определений фактических данных",
        "archived-groups": "Архивированные группы",
        "actuals-definitions-sort-order": "Порядок сортировки определений фактических данных",
        "assigned-task-types": "Назначенные типы задач",
        "group-in-use-cannot-alter-or-delete": "Эта группа используется, её название нельзя изменить, а саму группу — удалить.",
        "group-name": "Название группы",
        "assigned-definitions": "Назначенные определения",
        "assigned-tasks": "Назначенные задачи",
        "restore-group-definitions-warning": "Эта группа содержит определения, назначенные другим группам, которые будут удалены из этой группы при восстановлении.",
        "the-definitions-are": "Определения: ",
        "do-you-want-to-continue": "Хотите продолжить?"
    },
    "actuals-definitions": {
        "custom-value-set": "Пользовательский набор значений",
        "decimal-places": "Десятичные знаки",
        "field-type": "Тип поля",
        formula: "Формула",
        metric: "Метрика",
        summable: "Суммируемое",
        "value-set": "Набор значений",
        "actuals-definitions": "Определения фактических данных",
        "formula-hint": "Напр. [Длина бурения] * [Количество] + 15",
        "custom-value-set-hint": "Список значений через вертикальную черту (напр. ВариантA|ВариантB|ВариантC)",
        "value-set-data-type-mismatch": "Набор значений должен соответствовать выбранному типу данных",
        "archived-definitions": "Архивированные определения",
        "assigned-definition-groups": "Назначенные группы определений",
        "production-rate-type": "Тип производственной нормы",
        "only-numeric-types-may-target-a-production-rate": "Только числовые типы могут задавать производственную норму",
        "pick-a-driving-production-class": "Выберите ведущий производственный класс: Бурение, Зарядка или Погрузка (дистанционная и обычная).",
        "definition-assigned-to-mismatched-tasks": "Это определение назначено задачам (через назначенные группы определений), которые не соответствуют выбранному типу производственной нормы. Пожалуйста, убедитесь, что вы согласны с этим выбором.",
        "definition-in-use-cannot-alter": "Это определение используется и не может быть изменено или удалено. Его всё ещё можно архивировать или восстановить.",
        "definition-name": "Название определения",
        "assigned-groups": "Назначенные группы",
        "weight-t": "Вес (т)",
        "weight-kg": "Вес (кг)"
    },
    "ad-hoc-task-editor": {
        "remove-name": "Удалить {name}",
        "overridden-location-name": "Переопределённое название локации",
        "task-category": "Категория задачи",
        "task-type": "Тип задачи",
        "override-task-name": "Переопределить название задачи",
        "start-at": "Начало в",
        "duration-minutes": "Продолжительность (минуты)",
        "effort-minutes": "Трудозатраты (минуты)",
        priority: "Приоритет",
        consumables: "Расходные материалы",
        "start-chainage-m": "Начальный пикет (м)",
        "end-chainage-m": "Конечный пикет (м)",
        "edit-task": "Редактировать задачу",
        "add-task": "Добавить задачу"
    },
    "add-cycles": {
        "remove-name": "Удалить {name}",
        "cycle-type": "Тип цикла",
        select: "Выбрать",
        "cycle-has-no-tasks": "Цикл не содержит задач",
        "target-term": "Цель {term}",
        "add-before": "Добавить перед",
        "add-cycle": "Добавить цикл",
        warning: "Внимание!",
        "inserting-cycles-warning": "Вставка циклов в план может сдвинуть более поздние циклы"
    },
    "add-cycles-from-shift-dialog": {
        "start-at": "Начало в",
        "add-cycle": "Добавить цикл",
        "cycle-type": "Тип цикла",
        "cycle-has-no-tasks": "Цикл не содержит задач",
        "must-provide-cycle-start-time": "Необходимо указать время начала цикла.",
        "cycle-start-time-must-fall-within-shift": "Время начала цикла должно попадать в пределы смены."
    },
    "add-location": {
        search: "Поиск",
        "select-all": "Выбрать всё",
        select: "Выбрать"
    },
    "add-task-dialog": {
        "ring-is-already-status": "Веер уже {status}",
        "ring-is-status-would-skip": "Веер {status}. Это пропустит {skipped}",
        "ring-not-reached-target": "Веер ещё не достиг цели для {status}.",
        "ring-already-completed-target": "Веер уже выполнил целевое количество для {status}.",
        "duration-minutes": "Продолжительность (минуты)",
        quantity: "Количество",
        "rate-calculated": "Норма (рассчитано)",
        "start-at": "Начало в",
        standard: "Стандарт",
        rings: "Веера",
        "add-task": "Добавить задачу",
        "fire-duration-cannot-be-changed": "Продолжительность взрыва нельзя изменить.",
        "task-type": "Тип задачи",
        "term-task": "Задача {term}",
        "manually-add-task": "Добавить задачу вручную",
        "add-task-before": "Добавить задачу перед...",
        "add-task-after": "Добавить задачу после...",
        "must-provide-starting-time-for-task": "Необходимо указать время начала задачи.",
        "task-start-time-must-fall-within-shift": "Время начала задачи должно попадать в пределы смены.",
        "not-all-rings-are-charged": "Не все веера заряжены.",
        "not-all-rings-have-completed-charging": "Не все веера завершили зарядку.",
        "blast-packet-already-fired": "Взрывной пакет уже взорван.",
        "blast-packet-already-started-bogging": "Для взрывного пакета уже начата погрузка.",
        "blast-packet-not-yet-fired": "Взрывной пакет ещё не взорван.",
        "bogging-marked-complete": "Погрузка для взрывного пакета отмечена как завершённая.",
        "blast-packet-already-completed-bogging-quantity": "Взрывной пакет уже выполнил целевое количество погрузки."
    },
    "assign-shift-owner": {
        "i-confirm-that-i-have-permission-to-take": "Я подтверждаю, что имею разрешение принять владение сменой.",
        "select-user": "Выберите пользователя",
        "handover-meeting-not-complete": "Совещание по передаче смены не завершено",
        "open-handover-meeting": "Открыть совещание по передаче смены",
        "shift-planner": "Планировщик смены",
        "confirm-handover-meeting-not-complete": "Я подтверждаю, что совещание по передаче смены не завершено.",
        "confirm-user-no-shift-planner-role": "Я подтверждаю, что у выбранного пользователя нет роли Планировщик смены."
    },
    "audit-event-explorer": {
        "date-range": "Диапазон дат",
        "event-type": "Тип события",
        "from-date": "С даты",
        namespace: "Пространство имён",
        "to-date": "По дату",
        advanced: "Расширенные",
        "last-7-days": "Последние 7 дней",
        "last-30-days": "Последние 30 дней",
        "last-90-days": "Последние 90 дней"
    },
    "blast-packet-ring-changes-dialog": {
        "duration-minutes": "Продолжительность (минуты)",
        minutes: "Минуты",
        "proceed-without-updating": "Продолжить без обновления",
        "changed-drill-length-from": "Изменена длина бурения с",
        "changed-charge-amount-from": "Изменено количество заряда с",
        "changed-extraction-amount-from": "Изменено количество извлечения с",
        "no-additional-levels": "Нет дополнительных горизонтов, добавьте их ниже"
    },
    board: {
        "shift-date": "Смена {date}",
        "add-name": "Добавить {name}",
        "some-locations-visible-even-if-filtered": "Некоторые {term} могут отображаться, даже если отфильтрованы, из-за наличия зависимых задач",
        "you-are-currently-assigning": "Вы сейчас назначаете {equipment}",
        "row-task-update-for": "Обновление задачи строки для {taskId}",
        "add-cycle": "Добавить цикл",
        "eos-status": "СТАТУС КОНЦА СМЕНЫ",
        "sos-status": "СТАТУС НАЧАЛА СМЕНЫ",
        "shift-board": "Доска смены",
        "exit-by-pressing-ctrl-y-this-mode-disables-certain-constraints-on-board-tasks-use-with-caution": "Выйдите, нажав \"CTRL+Y\". Этот режим отключает некоторые ограничения на задачи доски. ИСПОЛЬЗУЙТЕ С ОСТОРОЖНОСТЬЮ.",
        "add-manual-task": "Добавить задачу вручную",
        "choose-action": "Выберите действие",
        "editing-actuals": "Вы сейчас редактируете фактические данные.",
        "highlighting-unresourced-tasks": "Выделение необеспеченных ресурсами задач",
        "location-utilisation": "Использование локаций",
        "utilisation-priority-1": "Процент использования локаций приоритета 1 в этой смене",
        "utilisation-priority-2": "Процент использования локаций приоритета 2 в этой смене",
        "utilisation-lower-priority": "Процент использования локаций более низкого приоритета в этой смене",
        "plan-manual-cycle": "Запланировать ручной цикл?",
        "manual-cycle-warning-1": "Ordo разработан для создания плана смены на основе существующего недельного плана.",
        "manual-cycle-warning-2": "Необходимость добавления ручного цикла указывает на то, что недельный план не был разработан.",
        "manual-cycle-warning-3": "Предпочтительно добавлять циклы в недельную доску.",
        "manual-cycle": "Ручной цикл",
        "promoting-fire-task-to-stope": "Повышение задачи взрыва до камеры.",
        "could-not-find-did-not-fire-task-type": "Не удалось найти тип задачи «не взорвано»",
        "filtering-locations-warning": "Вы фильтруете локации без активности и можете не увидеть новую локацию.",
        "actuals-saved": "Фактические данные сохранены",
        "update-task-error-reloading": "При обновлении задачи произошла непредвиденная ошибка. Перезагрузка данных смены с сервера.",
        "update-task-error-baseline": "При обновлении задачи произошла непредвиденная ошибка. Все изменения, сделанные офлайн, будут сохранены как базовая линия.",
        "update-task-error": "При обновлении задачи произошла непредвиденная ошибка",
        unavailable: "Недоступно",
        "manage-conflict": "Управление конфликтом"
    },
    "child-location-editor": {
        "display-order": "Порядок отображения",
        "is-drawpoint": "Является выпускной выработкой",
        level: "Горизонт",
        "must-not-match-existing-display-order-in-stope": "Не должно совпадать с существующим порядком отображения в камере.",
        "location-must-be-in-format": "Локация должна быть в формате '{format}'"
    },
    "communications-configuration": {
        "must-be-or-less-characters": "Должно быть не более {num} символов",
        department: "Отдел",
        description: "Описание",
        "icon-colour": "Цвет значка",
        type: "Тип",
        "week-or-shift": "Неделя или смена?",
        "communications-configuration": "Настройка коммуникаций",
        "comms-field": "Поле коммуникаций",
        "weekly-comms-fields": "Поля недельных коммуникаций",
        "shift-comms-fields": "Поля сменных коммуникаций",
        "archived-comms-fields": "Архивированные поля коммуникаций",
        persistence: "Сохранение",
        order: "Порядок",
        "fields-reordered": "Поля переупорядочены"
    },
    "connect-devices": {
        department: "Отдел",
        "generate-registration-code-now": "Сгенерировать код регистрации сейчас",
        code: "Код",
        "code-expires": "Срок действия кода",
        "code-refreshed": "Код обновлён",
        "copied-to-clipboard": "Скопировано в буфер обмена",
        "failed-to-copy": "Не удалось скопировать"
    },
    "create-blast-packet-dialog-v2": {
        cycle: "Цикл",
        "duration-minutes": "Продолжительность (минуты)",
        minutes: "Минуты",
        ring: "Веер",
        stope: "Камера",
        "enter-blast-packet-design-details": "Введите детали проекта взрывного пакета",
        "create-term-dialog": "Диалог создания {term}",
        "cycles-must-contain-drill-charge": "Циклы должны содержать задачи бурения и зарядки и не содержать задач взрыва или погрузки.",
        "add-term": "Добавить {term}",
        "no-additional-levels": "Нет дополнительных {term}, добавьте их ниже",
        "term-fire-task": "Задача взрыва {term}",
        "term-bog-task": "Задача погрузки {term}",
        "tolerance-percent": "Допуск (%)",
        "at-least-one-term-must-be-added": "Необходимо добавить хотя бы один {term}."
    },
    "create-user-dialog": {
        email: "Эл. почта",
        "initial-password": "Начальный пароль",
        roles: "Роли",
        select: "Выбрать {term}",
        "add-user": "Добавить пользователя"
    },
    crews: {
        "select-departments": "Выберите отделы",
        "cannot-import-no-staff-roles-available": "Невозможно импортировать: нет доступных ролей персонала.",
        roles: "Роли",
        count: "Количество"
    },
    cycles: {
        "custom-term": "Пользовательский {term}",
        "archived-term": "Архивированный {term}",
        abbreviation: "Аббревиатура",
        minutes: "Минуты",
        "metres-to-advance": "Метры проходки",
        "must-be-greater-than-or-equal-to-0": "Должно быть больше или равно 0",
        "metres-to-advance-hint": "Насколько этот цикл продвинет локацию. Оставьте пустым или установите ноль для щелевых врубов и т.п.",
        "text-colour": "Цвет текста",
        sample: "Образец:",
        "fire-tasks-cannot-change-default-duration": "Задачи взрыва не могут изменить свою продолжительность по умолчанию"
    },
    default: {
        "please-select-a-shift-to-begin": "Пожалуйста, выберите смену для начала"
    },
    "department-creation-wizard": {
        "cycle-name": "Название цикла",
        "cycle-name-plural": "Название цикла (множественное число)",
        "enforce-cycles-on-development-board": "Применять циклы на доске проходки?",
        "intended-use": "Назначение",
        "location-name": "Название локации",
        "location-name-abbreviation": "Название локации (аббревиатура)",
        "location-name-plural": "Название локации (множественное число)",
        "locations-in-resource-planning": "Локации в планировании ресурсов?",
        "show-on-mine-interaction-board": "Показывать на доске взаимодействий рудника?",
        general: "Общий",
        "use-for-general-mining-activities-including-development-production-and-services": "Используйте для общих горных работ, включая проходку, добычу и обслуживание.",
        maintenance: "Техобслуживание",
        "use-for-maintenance-activities": "Используйте для работ по техобслуживанию.",
        note: "Примечание:",
        config: "Настройка",
        "departments-require-some-specific-configuration-based-on-tasks-no-tasks-exist-for-this-department-yet-configure-tasks-and-then-update-this-department": "Отделы требуют определённой настройки на основе задач. Для этого отдела пока нет задач. Настройте задачи, а затем обновите этот отдел"
    },
    departments: {
        "cut-number-priority-cutoff": "Порог приоритета номера вруба",
        "cycle-name": "Название цикла",
        "cycle-name-plural": "Название цикла (множественное число)",
        "enforce-cycles-on-development-board": "Применять циклы на доске проходки?",
        "eos-task": "Задача конца смены?",
        "intended-use": "Назначение",
        "location-name": "Название локации",
        "location-name-abbreviation": "Название локации (аббревиатура)",
        "location-name-plural": "Название локации (множественное число)",
        "locations-in-resource-planning": "Локации в планировании ресурсов?",
        "show-on-mine-interaction-board": "Показывать на доске взаимодействий рудника?",
        "sos-tasks": "Задачи начала смены?",
        "task-type": "Тип задачи",
        note: "Примечание:",
        config: "Настройка",
        "departments-require-some-specific-configuration-based-on-tasks-no-tasks-exist-for-this-department-yet-configure-tasks-and-then-update-this-department": "Отделы требуют определённой настройки на основе задач. Для этого отдела пока нет задач. Настройте задачи, а затем обновите этот отдел",
        "hide-cut-number-chainage-hint": "Скрывать информацию о номере вруба и пикете на досках для локаций с приоритетом выше этого. Оставьте пустым, чтобы показывать на всех локациях.",
        "short-code": "Краткий код"
    },
    "edit-blast-packet-dialog-v2": {
        "duration-minutes": "Продолжительность (минуты)",
        minutes: "Минуты",
        stope: "Камера",
        "adding-additional-rings-to-a-blast-packet-is-not-supported": "Добавление дополнительных вееров во взрывной пакет не поддерживается.",
        "enter-blast-packet-design-details": "Введите детали проекта взрывного пакета",
        "edit-blast-packet-dialog": "Диалог редактирования взрывного пакета",
        "no-additional-levels-add-some-below": "Нет дополнительных горизонтов, добавьте их ниже",
        "term-bog-task": "Задача погрузки {term}",
        "tolerance-percent": "Допуск (%)"
    },
    "edit-equipment-dialog": {
        image: "Изображение",
        type: "Тип",
        "show-conflicts": "Показать конфликты",
        "select-departments": "Выбрать {term}",
        "equipment-has-activities-cannot-delete": "Для этого оборудования запланированы работы или оно назначено другой единице оборудования и не может быть удалено."
    },
    "edit-to-do-action-sheet": {
        description: "Описание",
        scope: "Область",
        title: "Заголовок",
        "creating-task-mine-area-visible": "Создание задачи в области рудника сделает её видимой во всех отделах.",
        "cannot-add-or-edit-tasks-whilst-offline": "Невозможно добавлять или редактировать задачи в автономном режиме."
    },
    "equipment-downtime-codes": {
        code: "Код",
        order: "Порядок",
        "downtime-code": "Код простоя",
        "archived-downtime-codes": "Архивированные коды простоя",
        "codes-reordered": "Коды переупорядочены"
    },
    "equipment-location-creation-wizard": {
        "select-term-to-plan": "Выберите {term} для планирования.",
        "ignores-start-of-shift-tasks": "Игнорирует задачи начала смены?",
        "independent-end-of-shift": "Независимый конец смены?",
        priority: "Приоритет",
        "an-archived-equipment-location-exists-with-this-name-have-you-considered-restoring-it-instead-of-creating-a-new-one": "Существует архивированная локация оборудования с этим названием. Не рассматривали ли вы её восстановление вместо создания новой?"
    },
    "equipment-roles": {
        "archived-term": "Архивированный {term}",
        "standard-term": "Стандартный {term}.",
        "crew-type": "Тип бригады",
        "supports-special-display-options": "Поддерживает специальные параметры отображения в печатных пакетах, напр. задачи бригады обслуживания."
    },
    "export-actual-physicals": {
        "from-time": "С времени",
        "export-physicals-range": "Диапазон экспорта физических показателей",
        all: "Все",
        "last-90-days": "Последние 90 дней",
        custom: "Пользовательский",
        "export-physicals": "Экспорт физических показателей",
        "to-time": "По время",
        "from-time-before-to-time": "Время «с» должно быть раньше времени «по»."
    },
    "filtered-select": {
        search: "Поиск"
    },
    "generate-reporting-months-dialog": {
        "generate-calendar-months": "Сгенерировать календарные месяцы",
        "target-year": "Целевой год",
        "template-year": "Год-шаблон",
        "use-template-year": "Использовать год-шаблон",
        generate: "Сгенерировать",
        "year-must-be-4-digits": "Год должен состоять из 4 цифр",
        "add-reporting-months": "Добавить отчётные месяцы",
        "template-year-not-same-as-target": "Год-шаблон не должен совпадать с целевым годом."
    },
    "hazard-categories": {
        description: "Описание",
        order: "Порядок",
        "short-name": "Краткое название",
        category: "Категория",
        "archived-downtime-codes": "Архивированные коды простоя",
        "categories-reordered": "Категории переупорядочены"
    },
    "hazard-notes-sheet": {
        "hazards-for": "Опасности - {name}",
        "add-new-hazard": "Добавить новую опасность",
        "add-hazard": "Добавить опасность",
        "cannot-remove-hazards-from-other-departments": "Невозможно удалить опасности из других отделов.",
        "undo-removal": "Отменить удаление",
        "remove-hazard": "Удалить опасность",
        "marked-for-removal": "(Отмечено для удаления)",
        "reported-from-ordo-connect": "Сообщено из ORDO Connect",
        "new-hazards": "Новые опасности",
        "removing-hazards-not-supported-offline": "Удаление опасностей не поддерживается в автономном режиме. При сохранении сейчас будут добавлены только новые опасности.",
        "abandon-hazard-changes-message": "Вы обновили опасности, но должны нажать кнопку \"Сохранить\", чтобы сохранить изменения. Вы уверены, что хотите их отменить?",
        "discard-partial-hazard-message": "Вы частично ввели опасность, но не добавили её. Вы уверены, что хотите её отменить?"
    },
    "heading-details": {
        priority: "Приоритет",
        "survey-memo": "Маркшейдерская заметка",
        "ground-support-profile": "Профиль крепления",
        "term-plan": "План {term}",
        "cannot-edit-whilst-offline": "Невозможно редактировать в автономном режиме.",
        "must-have-week-planner-role": "Требуется роль Планировщик недели.",
        unavailable: "Недоступно",
        "unavailability-reason": "Причина недоступности",
        details: "Детали",
        "variance-to-plan-comments": "Комментарии к отклонению (от плана)",
        "add-note": "Добавить заметку",
        "add-hazard": "Добавить опасность",
        "abandon-location-changes-message": "Вы обновили информацию о локации, но должны нажать кнопку \"Сохранить\", чтобы сохранить изменения. Вы уверены, что хотите их отменить?",
        "please-select-image-or-pdf": "Пожалуйста, выберите изображение или файл PDF"
    },
    "icon-selector": {
        icon: "Значок",
        search: "Поиск"
    },
    "import-equipments-availability-plan": {
        from: "С",
        review: "Проверка",
        "service-type": "Тип обслуживания",
        "starts-at": "Начинается в",
        "ends-at": "Заканчивается в",
        "import-equipment-availability-plan": "Импорт плана доступности оборудования",
        "existing-data-found-between-provided-date-range-will-be-replaced-or-removed": "Существующие данные, найденные в указанном диапазоне дат, будут заменены или удалены",
        "existing-data-that-overlap-provided-date-range-below-will-be-affected": "Существующие данные, пересекающиеся с указанным диапазоном дат ниже, будут затронуты",
        "imported-data-that-is-not-between-provided-date-range-below-will-be-skipped": "Импортируемые данные, которые не входят в указанный диапазон дат ниже, будут пропущены",
        to: "По:"
    },
    "import-key-physical-targets-dialog": {
        line: "Строка {number}",
        "from-date": "С даты",
        "select-month": "Выберите месяц",
        "unknown-target-type": "Неизвестный тип цели",
        "import-key-physical-targets": "Импорт целей ключевых физических показателей",
        validate: "Проверить",
        "import-file-details": "Детали файла импорта",
        "import-for-term": "Импорт для {term}",
        "aid-in-importing-download-template": "Чтобы облегчить импорт целей, пожалуйста, скачайте шаблон.",
        "each-line-single-target": "Каждая строка в файле импорта соответствует одной цели.",
        "detail-shift": ": Номер смены для цели.",
        date: "Дата",
        "detail-date": ": Дата цели в формате ГГГГ-ММ-ДД.",
        target: "Цель",
        "detail-target": ": Значение цели.",
        "target-type": "Тип цели",
        "detail-target-type": ": Тип цели (напр. Пройденные метры, Взрывы). Для пользовательских типов целей используйте название, заданное в администрировании.",
        "import-for-month": "Импорт для месяца",
        "year-not-found": "Год не найден в отчётных годах. Сгенерируйте его здесь или создайте вручную.",
        "generate-calendar-year": "Сгенерировать календарный год",
        "copy-previous-year": "Скопировать предыдущий год",
        "import-issues-resolve": "В вашем импорте есть одна или несколько проблем. Пожалуйста, устраните их перед продолжением",
        "target-type-label": "Тип цели:",
        "target-shift-label": "Целевая смена:",
        "target-date-label": "Целевая дата:",
        "target-value-label": "Целевое значение:",
        "import-may-have-issues": "Возможно, с вашим импортом были проблемы",
        "unknown-error": "Неизвестная ошибка"
    },
    "import-staff-availability-plan": {
        from: "С",
        review: "Проверка",
        type: "Тип",
        "import-staff-availability-plan": "Импорт плана доступности персонала",
        "existing-data-found-between-provided-date-range-will-be-replaced-or-removed": "Существующие данные, найденные в указанном диапазоне дат, будут заменены или удалены",
        "imported-data-that-is-not-between-provided-date-range-below-will-be-skipped": "Импортируемые данные, которые не входят в указанный диапазон дат ниже, будут пропущены",
        "import-leave-records": "Импорт записей об отпусках",
        "import-overtime-records": "Импорт записей о сверхурочных",
        "error-importing-plan": "Произошла ошибка при импорте вашего плана доступности персонала",
        "plan-saved-successfully": "План доступности персонала успешно сохранён"
    },
    "inspection-categories": {
        description: "Описание",
        order: "Порядок",
        "short-name": "Краткое название",
        "show-most-recent": "Показать последние",
        category: "Категория",
        "archived-categories": "Архивированные категории",
        "categories-reordered": "Категории переупорядочены"
    },
    "levelled-resources": {
        "resource-under-utilisation": "Недоиспользование ресурса (%)",
        "levelled-resources": "Выровненные ресурсы",
        "must-be-less-than-resource-level-target": "Должно быть меньше целевого уровня ресурса.",
        "archived-resources": "Архивированные ресурсы",
        "utilisation-under-flagged": "Проценты использования ниже этого значения будут отмечены.",
        "resource-level-target": "Целевой уровень ресурса (%)",
        "must-be-greater-than-resource-under-utilisation": "Должно быть больше, чем недоиспользование ресурса.",
        "utilisation-over-flagged": "Проценты использования выше этого значения будут отмечены.",
        "tooltime-minutes": "Время работы инструментом (минуты)",
        "minutes-per-shift-explanation": "Количество минут за смену, которое сотрудник в этом ресурсе должен быть в состоянии отработать.",
        "suggest-assignments": "Предложить назначения",
        "assigned-task-types": "Назначенные типы задач",
        "assigned-staff-roles": "Назначенные роли персонала",
        "resources-reordered": "Ресурсы переупорядочены"
    },
    "location-commentary-sheet": {
        "notes-for": "Заметки - {title}",
        "show-previous-notes": "Показать {count} предыдущих {noteWord}",
        comment: "Комментарий",
        "save-note": "Сохранить заметку",
        "discard-changes": "Отменить изменения",
        "no-notes": "Нет заметок",
        "cannot-add-or-alter-notes-if-offline": "Невозможно добавлять или изменять заметки в автономном режиме",
        "edit-notes": "Редактировать заметки",
        "add-note": "Добавить заметку",
        "no-history": "Нет истории"
    },
    "location-creation-wizard": {
        "default-cycle": "Цикл по умолчанию",
        "ignores-start-of-shift-tasks": "Игнорирует задачи начала смены?",
        "independent-end-of-shift": "Независимый конец смены?",
        "parent-location": "Родительская локация",
        priority: "Приоритет",
        "start-cut-number": "Начальный номер вруба",
        status: "Статус",
        development: "Проходка",
        "use-for-development-work": "Используйте для проходческих работ.",
        "ad-hoc": "Разовая",
        "use-for-ad-hoc-operations-like-services": "Используйте для разовых операций, таких как обслуживание.",
        stoping: "Очистная выемка",
        "use-for-all-stopes": "Используйте для всех камер.",
        "stoping-subheading": "Очистная выемка - Подзаголовок",
        "use-for-stope-children": "Используйте для дочерних элементов камеры.",
        "sub-level-caving": "Подэтажное обрушение",
        "use-for-sub-level-caving": "Используйте для подэтажного обрушения.",
        "an-archived-location-exists-with-this-name-have-you-considered-restoring-it-instead-of-creating-a-new-one": "Существует архивированная локация с этим названием. Не рассматривали ли вы её восстановление вместо создания новой?",
        "bogging-horizon": "Горизонт погрузки",
        "must-be-positive-integer": "Должно быть положительным целым числом"
    },
    "location-tracker": {
        "show-completed-term": "Показать завершённые {term}",
        "could-not-find-tarp": "Не удалось найти TARP с id {id}",
        "material-destination": "Назначение материала",
        "material-type": "Тип материала",
        stockpile: "Склад",
        "stockpile-status": "Статус склада",
        completed: "завершено",
        archived: "Архивировано",
        "tracker-board": "Доска отслеживания",
        "location-status": "Статус локации"
    },
    locations: {
        "allows-planning-against-equipment": "Позволяет планировать задачи для {equipment} вместо {location}.",
        "standard-term": "Стандартный {term}.",
        "add-child-term": "Добавить дочерний {term}.",
        "archived-term": "Архивированный {term}",
        "child-term-saved": "Дочерний {term} сохранён",
        "cycle-type": "Тип цикла",
        "default-cycle": "Цикл по умолчанию",
        "ignores-start-of-shift-tasks": "Игнорирует задачи начала смены?",
        "independent-end-of-shift": "Независимый конец смены?",
        level: "Горизонт",
        "mining-method": "Метод добычи",
        priority: "Приоритет",
        "start-cut-number": "Начальный номер вруба",
        status: "Статус",
        "cannot-import-no-reduced-levels-available-for-this-mine-area": "Невозможно импортировать: для этой области рудника нет доступных приведённых горизонтов.",
        "this-location-has-activities-planned-and-cannot-be-deleted": "Для этой локации запланированы работы, и она не может быть удалена.",
        "must-be-a-positive-integer": "Должно быть положительным целым числом"
    },
    "material-destinations": {
        abbreviation: "Аббревиатура"
    },
    "material-types": {
        abbreviation: "Аббревиатура"
    },
    "meeting-guide": {
        search: "Поиск",
        "shift-deployment": "Развёртывание смены",
        "shift-handover": "Передача смены",
        "shift-interactions": "Взаимодействия смены"
    },
    "mine-areas": {
        "first-day-of-week": "Первый день недели",
        "first-shift-starts-at": "Первая смена начинается в",
        "shift-overlap-minutes": "Перекрытие смен (минуты)",
        "shift-schedule": "Расписание смен",
        "shifts-per-day": "Смен в день",
        "start-counting-weeks-from": "Начать отсчёт недель с",
        "temperature-scale": "Температурная шкала",
        "shift-timings": "Время смен",
        updating: "Обновление...",
        "change-temperature-scale": "Изменить температурную шкалу",
        "time-zone": "Часовой пояс",
        "shift-1-name": "Название смены 1",
        "shift-2-name": "Название смены 2",
        "shift-3-name": "Название смены 3",
        "shift-4-name": "Название смены 4",
        logo: "Логотип",
        sending: "Отправка...",
        "upload-logo": "Загрузить логотип",
        "logo-dimensions-hint": "Логотипы в идеале должны быть высотой 74 пикселя и не более 250 пикселей в ширину. Для отображения на белом фоне. Только PNG",
        "location-name-convention": "Соглашение об именовании локаций",
        "bad-format": "Неверный формат",
        "location-convention-hint": "A = буква, N = цифра, . = любой символ, * = много. Напр. `A._N*` или `.* A*`",
        "show-help": "Показать справку",
        "test-location-pattern": "Проверить шаблон локации",
        "enter-location-name-to-test": "Введите название локации для проверки",
        "location-pattern-help": "A = 1 буква         A* = много букв\nN = 1 цифра         N* = много цифр\n? = 1 буква или цифра  ?* = много букв или цифр\n. = любой 1 символ  .* = много символов\n\nДругие разрешённые символы: - _ / и пробелы\nнапр. `A._D*` соответствует H2_123 и HA_444",
        "hide-help": "Скрыть справку",
        configuration: "Конфигурация",
        "shift-overlap-mins": "Перекрытие смен (мин)",
        "location-names": "Названия локаций",
        "temperature-scale-updated": "Температурная шкала обновлена",
        "failed-to-update-temperature-scale": "Не удалось обновить температурную шкалу",
        "please-select-image-or-pdf-file": "Пожалуйста, выберите изображение или файл PDF"
    },
    "move-rings-from-blast-packet-dialog": {
        "source-extraction": "Исходное извлечение {unit}",
        "target-extraction": "Целевое извлечение {unit}",
        "blast-packet": "Взрывной пакет",
        "rings-to-move": "Веера для перемещения",
        tolerance: "Допуск (%)",
        move: "Переместить",
        "i-acknowledge-that-this-will-leave-the-blast-packet-with-no-rings-deleting-it": "Я понимаю, что это оставит взрывной пакет без вееров, удалив его",
        "move-rings-dialog": "Диалог перемещения вееров",
        "move-title": "Переместить {items} из {source}",
    },
    "multiple-filtered-select": {
        search: "Поиск",
        "select-all": "Выбрать всё"
    },
    "pending-sync-warning-dialog": {
        "navigate-with-pending-count": "Пользователь попытался перейти с {count} ожидающими запросами в очереди в {timestamp}",
        "unsaved-changes": "Несохранённые изменения",
        "continue-working": "Продолжить работу",
        "schedule-changes-are-still-being-saved-to-the-server": "Изменения расписания всё ещё сохраняются на сервере."
    },
    "planning-drawer-actions": {
        "show-blast-packet-tasks": "Показать задачи взрывного пакета"
    },
    "plod-entry": {
        "show-term": "Показать {term}",
        "error-deleting-term": "Ошибка удаления {term}",
        "error-populating-actuals-from-shift-plan": "Ошибка заполнения фактических данных из плана смены: {error}",
        "error-marking-reportable": "Ошибка отметки фактических данных как готовых к отчётности: {error}",
        "error-marking-not-reportable": "Ошибка отметки фактических данных как не готовых к отчётности: {error}",
        "error-copying-task-times": "Ошибка копирования времени задач из плана смены: {error}",
        "error-loading-operator-completion": "Ошибка загрузки информации о завершении оператором: {error}",
        "error-loading-rejected-tasks": "Ошибка загрузки отклонённых задач: {error}",
        equipment: "Оборудование",
        formula: "Формула",
        plods: "Записи выработки",
        duplicates: "Дубликаты",
        "sync-times": "Синхронизировать время",
        complete: "% Завершено",
        "task-type": "Тип задачи",
        operator: "Оператор",
        "show-delays": "Показать задержки",
        "view-operator-plod-completion-information": "Просмотр информации о завершении записей выработки оператором.",
        "view-potential-duplicates": "Просмотр потенциальных дубликатов.",
        "pull-start-and-end-times": "Извлечь время начала и окончания для записей из плана смены.",
        "add-plod-entry": "Добавить запись выработки",
        "undo-completion": "Отменить завершение",
        "no-actuals-data-found": "Не найдено фактических данных, соответствующих этой смене и критериям фильтра.",
        "populate-data-for-shift": "Заполнить данные для смены",
        "sort-by-up-to-3-columns": "Сортировать по не более чем 3 столбцам",
        column: "Столбец",
        direction: "Направление",
        "add-level": "Добавить уровень",
        apply: "Применить",
        "task-type-column": "Задача (Тип)",
        "cut-number": "Вруб №",
        "start-chainage-m": "Начальный пикет (м)",
        "end-chainage-m": "Конечный пикет (м)",
        "start-time": "Время начала",
        "end-time": "Время окончания",
        "percentage-of-task-completed": "Процент задачи, выполненной в течение этой смены.",
        ignore: "Игнорировать",
        "row-will-not-save-until-task-type": "Строка не будет сохранена, пока не выбран тип задачи.",
        "represents-actuals-same-piece-of-work": "Представляет фактические данные, связанные с одним и тем же объёмом работ.",
        "reported-from-ordo-connect": "Сообщено из ORDO Connect.",
        "add-plod-entry-for-piece-of-work": "Добавить запись выработки для этого объёма работ.",
        "display-name": "Отображаемое имя",
        "enter-comments-here": "Введите комментарии здесь...",
        "ignore-row-for-reporting": "Игнорировать эту строку для отчётности (используйте для ввода дублирующих данных).",
        totals: "Итого",
        "rejected-tasks": "Отклонённые задачи",
        "plod-completion": "Завершение записей выработки",
        "viewing-potential-duplicates-read-only": "Просмотр потенциальных дубликатов - Только для чтения",
        "undo-deletion": "Отменить удаление",
        "actuals-populated-from-shift-plan": "Фактические данные заполнены из плана смены",
        "error-processing-formula": "Ошибка обработки формулы: ",
        "please-fix-validation-errors": "Пожалуйста, исправьте ошибки проверки перед сохранением.",
        "cancel-reportability": "Отменить готовность к отчётности",
        "confirm-mark-not-ready": "Вы уверены, что хотите отметить эти записи выработки как не готовые к отчётности?",
        "mark-reportable": "Отметить готовым к отчётности",
        "confirm-mark-ready": "Вы уверены, что хотите отметить эти записи выработки как готовые к отчётности?",
        "changes-still-possible": "Вы по-прежнему сможете вносить изменения после этого.",
        "marked-reportable": "Отмечено как готовое к отчётности",
        "marked-not-reportable": "Отмечено как не готовое к отчётности",
        "cannot-enter-both-cut-and-chainage": "Нельзя вводить одновременно Вруб № и значения пикета. Пожалуйста, используйте либо Вруб №, либо Начальный/Конечный пикет.",
        "both-chainage-together": "Начальный и конечный пикет должны вводиться вместе, либо не вводиться вовсе.",
        "end-chainage-greater-than-start": "Конечный пикет должен быть больше начального пикета.",
        "task-times-copied": "Время задач скопировано из плана смены",
        "copy-task-times": "Копировать время задач",
        "confirm-copy-task-times": "Вы уверены, что хотите скопировать время задач из плана смены?"
    },
    "production-front-locations-dialog": {
        search: "Поиск",
        select: "Выбрать",
        "select-all": "Выбрать всё",
        "replace-existing-locations": "Заменить существующие {term}"
    },
    "production-front-overlays-dialog": {
        "rotation-degrees": "Поворот (градусы)",
        scale: "Масштаб",
        "x-offset": "Смещение по X",
        "y-offset": "Смещение по Y",
        overlays: "Наложения",
        "overlay-saved": "Наложение сохранено"
    },
    "production-fronts": {
        "charge-sleep-expiry-days": "Срок выдержки заряда (дни)",
        department: "Отдел",
        "drill-charge-rule-distance": "Расстояние правила бурения/зарядки",
        "inter-level-drilling-rule-distance": "Расстояние правила межгоризонтного бурения",
        "intra-level-drilling-rule-distance": "Расстояние правила внутригоризонтного бурения",
        "maximum-lag-distance": "Максимальное расстояние отставания",
        "maximum-lead-distance": "Максимальное расстояние опережения",
        "maximum-tonnes-bogged": "Максимум погруженных тонн",
        "drill-charge-inter-level-rule": "Правило межгоризонтного бурения/зарядки",
        "drill-intra-level-rule": "Правило внутригоризонтного бурения",
        "drill-intralevel-rule": "Правило внутригоризонтного бурения",
        "charge-sleep-expiry-rule": "Правило срока выдержки заряда",
        "drawpoint-tonnes-bogged": "Погруженные тонны выпускной выработки",
        "drawpoint-lead-lag-ring-distances": "Расстояния опережения-отставания вееров выпускной выработки",
        "import-coordinates": "Импорт координат",
        "cannot-import-no-department-or-front": "Невозможно импортировать информацию о диаграмме, когда не выбран ни {term0}, ни {term1}"
    },
    "property-definition-dialog": {
        "new-value": "новое значение {number}",
        "display-order": "Порядок отображения",
        type: "Тип",
        value: "значение",
        "accepted-values": "Допустимые значения",
        "property-definition": "Определение свойства"
    },
    reporting: {
        department: "Отдел",
        description: "Описание",
        "equipment-role": "Роль оборудования",
        label: "Метка",
        "last-incident-date": "Дата последнего инцидента",
        "linked-actuals-definitions": "Связанные определения фактических данных",
        metric: "Метрика",
        "sub-category-name": "Название подкатегории",
        value: "Значение",
        reporting: "Отчётность",
        "physical-target-type": "Тип физической цели",
        "tracked-event-type": "Отслеживаемый тип события",
        "sub-categories": "Подкатегории",
        "tracked-count-type": "Отслеживаемый тип счёта",
        "tracked-days-since-last-incident-type": "Отслеживаемый тип дней с последнего инцидента",
        "select-an-equipment-role-for-the-department-daily-report-configuration-this-role-will-be-used-for-blast-info-first-work": "Выберите роль оборудования для конфигурации ежедневного отчёта отдела. Эта роль будет использоваться для информации о взрыве и первых работ.",
        "report-headers": "Заголовки отчёта",
        "equipment-role-and-headers": "Роль оборудования и заголовки",
        "import-reporting-calendar": "Импорт отчётного календаря",
        "export-reporting-calendar": "Экспорт отчётного календаря",
        "warning-this-target-type-may-not-function-correctly-without-at-least-one-actuals-definition": "Предупреждение: этот тип цели может работать некорректно без хотя бы одного определения фактических данных.",
        "as-this-is-a-system-defined-target-type-it-is-not-possible-to-associate-this-manually-to-actuals": "Поскольку это системный тип цели, невозможно связать его вручную с фактическими данными.",
        "this-physical-target-type-is-in-use-and-cannot-be-deleted": "Этот тип физической цели используется и не может быть удалён.",
        "this-physical-target-type-is-system-defined-and-cannot-be-deleted": "Этот тип физической цели определён системой и не может быть удалён.",
        "this-count-type-is-archived-you-can-restore-it-using-the-restore-button-in-the-list": "Этот тип счёта архивирован. Вы можете восстановить его с помощью кнопки восстановления в списке.",
        "this-incident-type-is-archived-you-can-restore-it-using-the-restore-button-in-the-list": "Этот тип инцидента архивирован. Вы можете восстановить его с помощью кнопки восстановления в списке.",
        "the-last-incident-date-can-only-be-set-when-creating-the-type-you-can-update-it-in-the-data-table-after-creation": "Дату последнего инцидента можно задать только при создании типа. Вы можете обновить её в таблице данных после создания.",
        "configure-report-equipment-and-headers": "Настроить оборудование и заголовки отчёта",
        "reporting-calendar": "Отчётный календарь",
        "physical-target-types": "Типы физических целей",
        "import-key-physical-targets": "Импорт целей ключевых физических показателей",
        "system-defined": "Определено системой",
        "tracked-event-types": "Отслеживаемые типы событий",
        "tracked-count-types": "Отслеживаемые типы счёта",
        "tracked-days-since-last-incident-types": "Отслеживаемые типы дней с последнего инцидента",
        "no-sub-categories-defined": "Подкатегории не определены. Нажмите \"Добавить\", чтобы создать подкатегории.",
        "event-type-archived-hint": "Этот тип события архивирован. Вы можете восстановить его с помощью кнопки восстановления в списке.",
        "add-report-header": "Добавить заголовок отчёта",
        "cannot-have-more-than-2-headers": "Нельзя иметь более 2 заголовков",
        "weekly-target": "Недельная цель",
        "daily-target": "Ежедневная цель",
        "weight-t": "Вес (т)",
        "weight-kg": "Вес (кг)",
        "invalid-sub-categories": "Недопустимые подкатегории",
        "all-sub-categories-must-have-a-name": "Все подкатегории должны иметь название. Пожалуйста, укажите названия для всех подкатегорий или удалите пустые.",
        "archive-event-type": "Архивировать тип события",
        "confirm-archive-event-type": "Вы уверены, что хотите архивировать этот тип события?",
        "restore-event-type": "Восстановить тип события",
        "confirm-restore-event-type": "Вы уверены, что хотите восстановить этот тип события?",
        "archive-count-type": "Архивировать тип счёта",
        "confirm-archive-count-type": "Вы уверены, что хотите архивировать этот тип счёта?",
        "restore-count-type": "Восстановить тип счёта",
        "confirm-restore-count-type": "Вы уверены, что хотите восстановить этот тип счёта?",
        "archive-incident-type": "Архивировать тип инцидента",
        "confirm-archive-incident-type": "Вы уверены, что хотите архивировать этот тип инцидента?",
        "restore-incident-type": "Восстановить тип инцидента",
        "confirm-restore-incident-type": "Вы уверены, что хотите восстановить этот тип инцидента?"
    },
    "resolve-conflict-dialog": {
        comments: "Комментарии",
        resolved: "Разрешено",
        "jump-to-department": "Перейти к отделу:"
    },
    resources: {
        "primary-equipment-utilisation": "Процент использования основного {term} в этой смене",
        "secondary-equipment-utilisation": "Процент использования вспомогательного {term} в этой смене",
        "support-equipment-utilisation": "Процент использования поддерживающего {term} в этой смене",
        "task-not-found": "Задача не найдена для локации {location} и задачи {task}",
        "show-unused": "Показать неиспользуемое",
        button: {
            "add-crew-role": "Добавить роль бригады",
            "copy-previous": "Скопировать предыдущее",
            "clear-staff": "Очистить персонал",
            "unplanned-leave": "Внеплановый отпуск"
        },
        heading: {
            "assigned-resources": "Назначенные ресурсы",
            "assigned-roles": "Назначенные роли",
            "availability-for": "Доступность для {name}",
            "comments-for": "Комментарии для {name}",
            crews: "Бригады",
            "primary-equipment": "Основное оборудование",
            resources: "Ресурсы",
            "secondary-equipment": "Вспомогательное оборудование",
            "support-equipment": "Поддерживающее оборудование",
            "clear-staff-confirm-prompt": "Очистить персонал",
            "add-crew-member": "Добавить члена бригады",
            "add-crew-role": "Добавить роль бригады"
        },
        label: {
            "current-location": "Текущая локация",
            "no-tasks": "Нет задач",
            unassigned: "Не назначено",
            "equipment-filtered": "Оборудование не видно из-за применённых фильтров"
        },
        message: {
            "no-crew-selected": "Бригада не выбрана",
            "clear-staff-confirmation": "Все назначения персонала очищены.",
            "clear-staff-confirm-prompt": "Вы уверены, что хотите очистить все назначения персонала?",
            "no-secondary-equipment-assigned": "Вспомогательное оборудование не назначено",
            "nothing-to-copy": "Нечего копировать - для этого отдела не найдена предыдущая смена с теми же выбранными бригадами: {crewNames}",
            "unplanned-leave-confirm": "Подтвердить внеплановый отпуск для смены",
            "copy-previous": "Распределения скопированы из предыдущей смены"
        },
        "hide-unavailable-term": "Скрыть недоступные {term}",
        "copy-previous-allocations": "Скопировать предыдущие распределения",
        "copy-previous-shift-allocations": "Скопировать распределения предыдущей смены?",
        yes: "Да",
        "primary-term": "Основной {term}",
        "secondary-term": "Вспомогательный {term}",
        "support-term": "Поддерживающий {term}",
        "changing-crews-will-clear-assigned-roles": "Изменение бригад очистит назначенные роли",
        "resource-utilisation": "Использование ресурсов",
        "percentage-utilisation-of-crew-members": "Процент использования членов бригады в этой смене",
        "staff-member-no-levelled-resource": "Сотруднику не назначен выровненный ресурс. Назначьте напрямую на задачи.",
        "staff-member-no-matching-tasks": "Сотрудник не соответствует ни одной задаче по выровненному ресурсу. Назначьте напрямую на задачи."
    },
    "ring-design-generation-dialog": {
        "display-order-in-use": "Порядок отображения {displayOrder} уже используется. Его использование вставит этот веер в эту позицию.",
        "charge-distance": "Расстояние зарядки",
        "drill-distance": "Расстояние бурения",
        "extraction-amount": "Количество извлечения",
        "hole-name": "Название скважины",
        "ring-order": "Порядок вееров",
        "select-number-of-holes": "Выберите количество скважин",
        "select-ring-template": "Выберите шаблон веера",
        generate: "Сгенерировать",
        reset: "Сбросить",
        "add-hole": "Добавить скважину",
        "must-have-at-least-one-hole": "Должна быть хотя бы одна скважина"
    },
    sandpit: {
        "department-name": "Отдел: {name}",
        "setup-week-plan-with-adjacent": "Настроить недельный план отделов на эту неделю {asAt}, вместе с планами предыдущей и следующей недель ",
        "setup-week-plan": "Настроить недельный план отделов на эту неделю {asAt} ",
        "blast-packets": "Взрывные пакеты",
        "comms-fields": "Поля коммуникаций",
        crews: "Бригады",
        cycles: "Циклы",
        equipment: "Оборудование",
        "last-week-plan-template": "Шаблон плана прошлой недели",
        levels: "Горизонты",
        locations: "Локации",
        "next-week-plan-template": "Шаблон плана следующей недели",
        overlays: "Наложения",
        rings: "Веера",
        "scenario-directory": "Каталог сценариев",
        "select-all-files-for-specific-scenarios": "Выбрать все файлы для конкретных сценариев",
        "select-all-visualisation-overlay": "Выбрать все наложения визуализации",
        tarps: "TARP",
        "task-types": "Типы задач",
        "visualisation-co-ordinates": "Координаты визуализации",
        "week-plan-template": "Шаблон недельного плана",
        "manage-the-sandpit-mine-area": "Управление областью рудника песочницы",
        "long-running-action": "Длительное действие",
        "import-all": "Импортировать всё",
        "populate-sandpit-data": "Заполнить данные песочницы",
        "setup-the-sandpit-mine-area-with-data-from-import-files": "Настроить область рудника песочницы данными из файлов импорта",
        "manage-department-data": "Управление данными отдела",
        "setup-the-sandpit-department-with-department-specific-data": "Настроить отдел песочницы данными, специфичными для отдела",
        "manage-week-plan": "Управление недельным планом",
        "manage-visualisation": "Управление визуализацией",
        "setup-the-departments-visualisation": "Настроить визуализацию отделов",
        "the-import-will-create-development-and-production-departments-this-can-take-approximately-15-minutes-to-complete": "- Импорт создаст отделы проходки и добычи. Это может занять примерно 15 минут.",
        "this-action-could-take-some-time-to-complete-it-is-creating-3-week-plans": "- Это действие может занять некоторое время. Оно создаёт 3 недельных плана",
        "creating-rings-and-blast-packets-can-take-some-time-to-complete": "- Создание вееров и взрывных пакетов может занять некоторое время",
        "creating-three-sub-level-caving-week-plans-can-take-approximately-5-10-minutes-to-complete": "- Создание трёх недельных планов подэтажного обрушения может занять примерно 5-10 минут.",
        "sandpit-loader": "Загрузчик песочницы"
    },
    "shift-board-row": {
        "hide-unavailability-sign": "Скрыть знак недоступности",
        "show-unavailability-sign": "Показать знак недоступности",
        unavailable: "Недоступно"
    },
    "shift-loader": {
        "shift-loader-name": "Загрузчик смены: {name}",
        "planning-for-this-week-has-not-started-create": "Планирование этой недели не начато. Создайте недельный план перед планированием этой смены",
        "shift-loader": "Загрузчик смены"
    },
    "shift-printer": {
        source: "Источник",
        "print-shift-packs": "Печать пакетов смены",
        "maintenance-shift-pack": "Пакет смены техобслуживания",
        "shift-pack": "Пакет смены",
        "compressed-shift-pack": "Сжатый пакет смены",
        "term-pack": "Пакет {term}",
        "term-details": "Детали {term}",
        "download-csv": "Скачать CSV",
        "training-shift-pack": "Учебный пакет смены",
        "blank-shift-plan": "Пустой план смены",
        "current-plan": "Текущий план",
        "publish-shift": "Опубликовать смену?",
        "would-you-like-to-publish-baseline": "Хотите опубликовать эту смену как базовую линию?",
        "failed-to-publish-shift": "Не удалось опубликовать смену.",
        "published-shift-as-baseline": "Смена опубликована как базовая линия."
    },
    "shift-reports": {
        "this-shift-published-baseline": "Эта смена опубликовала базовую линию",
        "baseline-for-previous-shift-not-found": "Базовая линия для предыдущей смены не найдена",
        "compare-last-24hr-actuals-to-published-plan": "Сравнить фактические данные за последние 24 часа с опубликованным планом",
        "shift-variance-report": "Отчёт об отклонениях смены",
        "previous-shift-published-baseline": "Предыдущая смена опубликовала базовую линию",
        "variance-report": "Отчёт об отклонениях",
        "current-plan": "Текущий план"
    },
    "shift-selector": {
        "week-commencing": "Неделя {weekNumber} нач. {date} ",
        date: "Дата",
        department: "Отдел",
        "mine-area": "Область рудника",
        "select-shift": "Выберите смену...",
        "select-shift-title": "Выберите смену",
        select: "Выбрать",
        "week-of": "Неделя",
        "mine-interactions-board": "Доска взаимодействий рудника"
    },
    "shift-task-actions": {
        "add-task-after": "Добавить задачу после",
        "add-task-before": "Добавить задачу перед",
        "delete-task": "Удалить задачу",
        "edit-quantity": "Редактировать количество",
        "edit-task": "Редактировать задачу",
        "send-to-next-shift": "Отправить в следующую смену",
        "show-planned-targets": "Показать запланированные цели",
        split: "Разделить",
        "switch-bogging-type": "Переключить тип погрузки",
        "show-usage": "Показать использование {term}"
    },
    "split-task-dialog": {
        "delay-duration": "Продолжительность задержки",
        "delay-type": "Тип задержки",
        "split-a-task-and-insert-a-delay": "Разделить задачу и вставить задержку",
        "split-task": "Разделить задачу",
        "can-t-split-tasks-which-are-shorter-than-45-minutes": "Невозможно разделить задачи короче 45 минут."
    },
    "staff-roles": {
        "archived-term": "Архивированный {term}",
        supervisor: "Руководитель?"
    },
    "standard-dialog": {
        "could-not-load-the-required-data-for-this": "Не удалось загрузить необходимые данные для этого диалога"
    },
    stockpiles: {
        abbreviation: "Аббревиатура",
        status: "Статус"
    },
    "subscribers-dialog": {
        "add-new-subscriber": "Добавить нового подписчика",
        events: "События",
        "notification-subscribers": "Подписчики уведомлений",
        "select-all": "Выбрать всё",
        "weekly-board": "Недельная доска",
        "must-not-match-existing-email": "Не должно совпадать с существующим адресом эл. почты.",
        "confirm-abandon-partially-added": "Вы частично добавили нового подписчика и должны нажать кнопку \"Добавить\", чтобы завершить процесс. Вы уверены, что хотите отменить изменения?",
        "confirm-abandon-partially-updated": "Вы частично обновили подписчика и должны нажать кнопку \"Обновить\", чтобы завершить процесс. Вы уверены, что хотите отменить изменения?"
    },
    "supervisor-actuals-tab": {
        "add-term-variance": "Добавить отклонение {term}",
        "heading-not-found": "Выработка с запланированным id локации {id} не найдена.",
        comment: "Комментарий",
        location: "Локация",
        comments: "Комментарии",
        "variance-to-plan": "Отклонение от плана",
        "add-variance-to-plan": "Добавить отклонение от плана",
        "remove-variance-reason": "Удалить причину отклонения"
    },
    "supervisor-safety-and-incidents-tab": {
        location: "Локация",
        safety: "Безопасность",
        "add-safety-incident": "Добавить инцидент безопасности",
        "add-safety-observation": "Добавить наблюдение по безопасности",
        "add-jsea": "Добавить JSEA",
        "add-condition-report": "Добавить отчёт о состоянии",
        incidents: "Инциденты",
        "add-condition-monitoring": "Добавить мониторинг состояния",
        "add-job-safety-environmental-analysis": "Добавить анализ безопасности и экологичности работ",
        "remove-incident": "Удалить инцидент",
        observations: "Наблюдения",
        "remove-observation": "Удалить наблюдение",
        "remove-jsea": "Удалить JSEA",
        "condition-monitoring": "Мониторинг состояния",
        "thermal-work-limit": "Термальный предел работы",
        "wet-bulb-temp": "Температура влажного термометра",
        "dry-bulb-temp": "Температура сухого термометра",
        activity: "Деятельность",
        "remove-condition-report": "Удалить отчёт о состоянии",
        time: "Время",
        "wet-bulb-temperature": "Температура влажного термометра",
        "dry-bulb-temperature": "Температура сухого термометра"
    },
    "task-categories": {
        "mine-area": "Область рудника"
    },
    "task-group-actions": {
        accept: "Принять",
        "edit-task": "Редактировать задачу",
        "show-blast-packet-tasks": "Показать задачи взрывного пакета"
    },
    "task-suggestion": {
        "duration-min": "Продолжительность: {minutes} мин ",
        "end-date": "Дата окончания",
        "end-time": "Время окончания",
        "planned-quantity": "Запланированное количество",
        "start-date": "Дата начала",
        "start-time": "Время начала",
        "add-task": "Добавить задачу",
        "duration-must-be-greater-than-0": "Продолжительность должна быть больше 0"
    },
    tasks: {
        "system-term": "Системный {term}",
        "custom-term": "Пользовательский {term}",
        "archived-term": "Архивированный {term}",
        abbreviation: "Аббревиатура",
        "category-type": "Тип категории",
        department: "Отдел",
        "name-future-tense": "Название (будущее время)",
        "name-when-in-progress": "Название в процессе выполнения",
        "system-task-class": "Системный класс задачи",
        "naming-tasks": "Именование задач",
        "future-tense-and-in-progress-are-the-names-used-to-refer-to-this-task-in-the-future-or-in-progress-e-g-for-bog-the-future-tense-would-be-to-bog-and-in-progress-would-be-bogging": "- 'будущее время' и 'в процессе' — это названия, используемые для обозначения этой задачи в будущем или в процессе. Напр. для 'Погрузить' будущее время будет 'Погрузить', а в процессе — 'Погрузка'",
        "this-a-system-setting-and-changing-this-will-have-system-wide-effects-changing-task-class-can-change-system-behaviour-this-is-an-administration-action-only": "- Это системная настройка, и её изменение будет иметь общесистемные последствия. Изменение класса задачи может изменить поведение системы. Это только административное действие.",
        "some-task-classes-removed": "Некоторые классы задач были удалены из списка, так как они уже используются.",
        "is-delay": "Является задержкой?",
        "allocate-actuals-to-next-cut": "Распределить фактические данные на следующий вруб?",
        "default-time-mins": "Время по умолчанию (мин)",
        "delay-type": "Тип задержки",
        metric: "Метрика",
        "linked-physical": "Связанный физический показатель",
        "task-colour": "Цвет задачи",
        "text-colour": "Цвет текста",
        sample: "Образец:",
        "default-split-delay-type": "Тип задержки разделения по умолчанию",
        "default-time-mins-col": "Время по умолчанию (мин)",
        "weight-t": "Вес (т)",
        "weight-kg": "Вес (кг)",
        "error-loading-actuals-definitions": "Ошибка загрузки определений фактических данных:",
        "term-imported": "{term} импортирован"
    },
    "tenant-change": {
        "select-org-mine": "Выберите Организацию/Рудник",
        "select-your-organisation-mine": "Выберите вашу Организацию/Рудник"
    },
    terms: {
        search: "Поиск",
        "show-as": "Показывать как",
        "show-as-plural": "Показывать как, множественное число"
    },
    "trigger-action-response-plans": {
        department: "Отдел",
        description: "Описание",
        "display-order": "Порядок отображения",
        order: "Порядок",
        "generate-3-status-tarp": "Сгенерировать 3-статусный TARP",
        "generate-5-status-tarp": "Сгенерировать 5-статусный TARP",
        "task-colour": "Цвет задачи"
    },
    "update-location-status-dialog": {
        status: "Статус",
        stope: "Камера"
    },
    "update-tarp-status-dialog": {
        status: "Статус",
        stope: "Камера",
        loader: "Диалог обновления статуса TARP",
        "confirm-set-existing-value": "Вы устанавливаете статус в его существующее значение. Вы уверены?"
    },
    "user-departments-dialog": {
        "select-departments": "Выберите отделы"
    },
    users: {
        search: "Поиск",
        "mdi-shield-check": "mdi-shield_check",
        "user-admin": "Администрирование пользователей",
        "confirm-delete": "Подтвердить УДАЛЕНИЕ",
        "confirm-deactivate": "Подтвердить деактивацию"
    },
    "week-equipment": {
        "start-at": "Начало в",
        "weekly-service": "Еженедельное обслуживание",
        "minor-service": "Малое обслуживание",
        "major-service": "Капитальное обслуживание",
        unserviceable: "Неисправен",
        "idle-unavailable-this-week": "Простой/Недоступен на этой неделе",
        services: "Обслуживания",
        "ends-at": "Заканчивается в",
        "must-be-greater-than-start": "Должно быть больше начала"
    },
    "week-resourcing": {
        "crew-this-week": "Бригада на этой неделе",
        "default-crew": "Бригада по умолчанию",
        available: "Доступно",
        "leave-in-week": "Отпуск на неделе",
        "overtime-in-week": "Сверхурочные на неделе",
        "add-staff": "+ Добавить персонал",
        unavailable: "Недоступно",
        "overtime-available": "Сверхурочные доступны",
        leave: "Отпуск",
        overtime: "Сверхурочные",
        "successfully-assigned-staff-to-crew": "Персонал успешно назначен в бригаду",
        "unable-to-assign-staff-to-crew": "Не удалось назначить персонал в бригаду",
        "hide-unassigned": "Скрыть неназначенных",
        "show-unassigned": "Показать неназначенных"
    },
    weekly: {
        "add-name": "Добавить {name}",
        "remove-name": "Удалить {name}",
        "no-locations-can-be-removed": "Нет {term}, которые можно удалить",
        "unable-to-find-target-row": "Не удалось найти целевую строку для {name} ({id})",
        "task-type-not-found": "Тип задачи с id {id} не найден.",
        "unknown-action": "Неизвестное действие: {action}",
        "collapse-cycles": "Свернуть циклы",
        "export-adhoc-tasks": "Экспорт разовых задач",
        "planning-for-this-week-has-not-started": "Планирование этой недели не начато",
        "import-plan": "Импортировать план",
        "export-plan": "Экспортировать план",
        "copy-allocations-to-right": "Скопировать распределения {term} вправо",
        "export-assignments": "Экспорт назначений {term}",
        "week-plan": "Недельный план",
        "reset-plan": "Сбросить план",
        "export-week-plan-to-csv": "Экспорт недельного плана в CSV",
        "weekly-board": "Недельная доска",
        "change-shift-summary-row": "Изменить сводную строку смены",
        "start-planning": "Начать планирование",
        "weekly-board-export": "Экспорт недельной доски",
        "week-warnings": "Предупреждения недели",
        "editing-historic-cycles": "Вы сейчас редактируете исторические циклы!",
        "shift-info": "Информация о смене",
        "crew-information": "Информация о бригаде",
        "reset-week-plan": "Сбросить недельный план",
        "confirm-reset-week-plan": "Вы уверены, что хотите сбросить недельный план?",
        "reset-week-plan-warning": "Это удалит все задачи, начинающиеся в течение этой недели.",
        "promoting-fire-task-to-stope": "Повышение задачи взрыва до камеры.",
        "filtering-locations-warning": "Вы фильтруете локации без активности и можете не увидеть новую локацию.",
        "failed-export-week-plan": "Не удалось экспортировать недельный план.",
        "delete-name": "Удалить {name}",
        "confirm-delete-task": "Вы уверены, что хотите удалить эту задачу?",
        "week-targets-generated": "Недельные цели сгенерированы"
    },
    "daily-report": {
        "total-count": "Итого: {count}",
        "error-loading-daily-report": "Ошибка загрузки ежедневного отчёта: {error}",
        "error-generating-daily-report": "Ошибка генерации ежедневного отчёта: {error}",
        "error-regenerating-daily-report": "Ошибка повторной генерации ежедневного отчёта: {error}",
        "error-saving-daily-report": "Ошибка сохранения ежедневного отчёта: {error}",
        "error-marking-approved": "Ошибка отметки ежедневного отчёта как утверждённого: {error}",
        "error-marking-not-approved": "Ошибка отметки ежедневного отчёта как неутверждённого: {error}",
        "daily-report": "Ежедневный отчёт",
        "time-of-blast": "Время взрыва",
        "pic-safe": "PIC Safe",
        equip: "Обор.",
        "first-work-time": "Время первых работ",
        activity: "Деятельность",
        location: "Локация",
        comments: "Комментарии",
        "report-approved-for-use": "Отчёт утверждён для использования.",
        "enter-edit-mode": "Войти в режим редактирования",
        "save-and-exit": "Сохранить и выйти",
        "cancel-approval": "Отменить утверждение",
        approve: "Утвердить",
        "no-daily-report-found": "Ежедневный отчёт за эту дату не найден.",
        "generate-daily-report": "Сгенерировать ежедневный отчёт",
        "daily-report-cannot-be-created-in-future": "Ежедневный отчёт нельзя создать в будущем.",
        "locations-needing-re-entry": "Локации, требующие повторного ввода",
        "refresh-from-data-entry": "Обновить из ввода данных.",
        "to-alter-this-list": "Чтобы изменить этот список, пожалуйста, вернитесь и измените его на странице ввода данных.",
        "measurement-date": "Дата измерения",
        "to-date": "По дату",
        "hide-subcategories": "Скрыть подкатегории",
        "subcategories-available": "Подкатегории доступны",
        reset: "Сбросить",
        "row-will-not-save-until-equipment-selected": "Строка не будет сохранена, пока не выбрано оборудование.",
        "remove-first-work-activity": "Удалить деятельность первых работ.",
        "add-new-first-work-activity": "Добавить новую деятельность первых работ.",
        "add-new-comment": "Добавить новый комментарий.",
        remove: "Удалить.",
        "daily-report-generated-successfully": "Ежедневный отчёт успешно сгенерирован",
        "daily-report-regenerated-successfully": "Ежедневный отчёт успешно перегенерирован",
        "daily-report-saved-successfully": "Ежедневный отчёт успешно сохранён",
        "confirm-mark-not-approved": "Вы уверены, что хотите отметить этот ежедневный отчёт как неутверждённый?",
        "approve-report": "Утвердить отчёт",
        "confirm-mark-approved": "Вы уверены, что хотите отметить этот ежедневный отчёт как утверждённый?",
        "still-able-to-make-changes": "Вы по-прежнему сможете вносить изменения после этого.",
        "daily-report-approved": "Ежедневный отчёт утверждён",
        "daily-report-unapproved": "Утверждение ежедневного отчёта отменено"
    },
    "equipment-downtime": {
        equipment: "Оборудование",
        "downtime-code": "Код простоя",
        "duration-minutes": "Продолжительность (минуты)",
        comments: "Комментарии",
        "add-equipment-downtime": "Добавить простой оборудования",
        "no-data-available-in-the-table": "Нет данных в таблице."
    },
    "key-physical-actuals": {
        "error-populating-actuals-from-shift-plan": "Ошибка заполнения фактических данных из плана смены: {error}",
        cut: "Вруб №",
        "metres-advanced": "Пройденные метры",
        "start-chainage-m": "Начальный пикет (м)",
        "end-chainage-m": "Конечный пикет (м)",
        "tonnes-fired": "Взорванные тонны",
        "measured-tonnes-fired": "Измеренные взорванные тонны",
        "no-key-physicals-data-found": "Данные ключевых физических показателей не найдены.",
        "populate-data-for-shift": "Заполнить данные для смены",
        "add-metres-advanced": "Добавить пройденные метры",
        "add-tonnes-fired": "Добавить взорванные тонны",
        note: "Примечание:",
        "metres-advanced-readjust-warning": "Изменения пройденных метров (добавление / обновление / удаление) могут привести к пересчёту номеров врубов и начал пикетов ниже по потоку.",
        "cut-number": "Вруб №",
        "start-chainage": "Начальный пикет",
        "single-box-metres-advanced": "Пройденные метры (один блок)",
        "end-chainage": "Конечный пикет",
        "planned-metres-tooltip": "Запланированные пройденные метры из недельного плана. Введите значение для переопределения.",
        "updated-metres-tooltip": "Обновлённые пройденные метры. Удалите это значение, чтобы вернуться к значению недельного плана.",
        "averaged-value-tooltip": "Усреднённое значение для этого вруба согласно наиболее релевантной измеренной длине.",
        "actuals-populated-from-shift-plan": "Фактические данные заполнены из плана смены",
        "delete-cut": "Удалить вруб",
        "are-you-sure-delete-cut": "Вы уверены, что хотите удалить этот вруб? У всех фактических данных, связанных с этим номером вруба, связь будет удалена."
    },
    "admin-home": {
        administration: "Администрирование"
    },
    "navigation-drawer": {
        security: "Безопасность",
        sandpit: "Песочница",
        "clear-local-tenant-cache": "Очистить локальный кэш арендатора",
        configuration: "Конфигурация",
        "communications-configuration": "Настройка коммуникаций",
        reporting: "Отчётность",
        "local-tenant-information-cleared": "Локальная информация арендатора очищена."
    },
    "admin-sandpit-item-name": {
        sp: "(ПС)"
    },
    "admin-sandpit-visibility-selector": {
        "sandpit-visibility": "Видимость песочницы"
    },
    "admin-equipment": {
      "equipment": {
          "charger": "Зарядная машина",
          "service-crew": "Бригада обслуживания",
          "flatbed-truck": "Бортовой грузовик",
          "personnel-carrier": "Машина для перевозки персонала",
          "water-truck": "Поливочная машина",
          "tanker-truck": "Автоцистерна",
          "explosives-truck": "Машина для перевозки взрывчатки",
          "forklift": "Вилочный погрузчик",
          "drill-rig-surface": "Буровая установка (поверхностная)",
          "crane-franna": "Кран (Franna)",
          "service-truck": "Сервисный грузовик",
          "storeperson": "Кладовщик",
          "dump-truck-surface": "Самосвал (поверхностный)",
          "fuel-truck": "Топливозаправщик",
          "crane-mobile": "Кран (мобильный)",
          "digger-backhoe": "Экскаватор (обратная лопата)",
          "digger-front-end": "Экскаватор (фронтальный)",
          "dozer": "Бульдозер",
          "dragline": "Драглайн",
          "prime-mover-tipper-trailer": "Тягач с самосвальным прицепом",
          "electric-rope-shovel": "Электрическая канатная лопата",
          "cabolter": "Анкероустановщик (Cabolter)",
          "diamond-drill-rig": "Алмазная буровая установка",
          "lHD-loader": "ПДМ (погрузочно-доставочная машина)",
          "longhole-drill-rig": "Буровая установка для скважин",
          "refuge-chamber": "Камера-убежище",
          "scissor-lift": "Ножничный подъёмник",
          "sprayer": "Распылитель",
          "grader": "Грейдер",
          "charger-uphole": "Зарядная машина (восходящие скважины)",
          "compaction-roller": "Уплотняющий каток",
          "agitator-truck": "Автобетоносмеситель",
          "jumbo-drill-rig": "Буровая установка (Jumbo)",
          "integrated-toolcarrier": "Интегрированный инструментовоз",
          "dump-truck-underground": "Самосвал (подземный)",
          "light-vehicle-tray": "Лёгкий автомобиль (бортовой)",
          "light-vehicle-wagon": "Лёгкий автомобиль (фургон)",
          "raisebore-rig": "Установка для бурения восстающих",
          "spotter": "Наблюдатель",
          "plant": "Установка",
          "hydraulic-excavator": "Гидравлический экскаватор"
      }
    },
    "shift-schedule-editor": {
        "shift-name": "Название смены",
        "duration-minutes": "Продолжительность (минуты)",
        "shift-schedule": "Расписание смен",
        "each-day-must-have-shifts-that-total-exactly-1440-minutes-24-hours": "Каждый день должен иметь смены, суммарно составляющие ровно 1440 минут (24 часа).",
        "add-shift": "Добавить смену",
        "shift-schedule-saved": "Расписание смен сохранено",
        "failed-to-save-shift-schedule": "Не удалось сохранить расписание смен"
    },
    "stope-blast-packets-list": {
        "new-term": "Новый {term}",
        "delete-term": "Удалить {term}",
        "edit-term": "Редактировать {term}",
        "move-term": "Переместить {term}",
        loading: "Загрузка {term}",
        "last-updated": "Последнее обновление"
    },
    "task-debug": {
        "cycle-id": "Id цикла",
        "task-id": "Id задачи",
        correlation: "Корреляция",
        "auto-split": "Автоматическое разделение",
        "manual-split": "Ручное разделение",
        "different-from-config": "Отличается от конфигурации",
        "is-locked-in-past": "Заблокировано в прошлом"
    },
    "task-details-badge": {
        cut: "Вруб №:",
        quantity: "Количество:",
        chainage: "Пикет:",
        "not-set": "Не задано"
    },
    "captain-board": {
        "shift-interactions-date": "Взаимодействия смены {date}",
        "split-over-eos": "(разделено на конце смены)",
        legend: "Легенда",
        "shift-interactions": "Взаимодействия смены"
    },
    "interactions-side-drawer": {
        meetings: "Совещания",
        "shift-interactions": "Взаимодействия смены",
        "filters-and-groups": "Фильтры и группы",
        filters: "Фильтры",
        grouping: "Группировка",
        columns: "Столбцы",
        groupings: "Группировки",
        conflicts: "Конфликты",
        "interactions-side-drawer": "Боковая панель взаимодействий",
        "shift-interactions-meeting": "Совещание по взаимодействиям смены"
    },
    "stope-rings-list": {
        "new-term": "Новый {term}",
        reorder: "Переупорядочить",
        loading: "Загрузка {term}",
        "total-drill-distance": "Общее расстояние бурения",
        "total-charge": "Общий заряд",
        "extraction-amount": "Количество извлечения",
        "ring-order": "Порядок вееров",
        "last-updated": "Последнее обновление"
    },
    "development-tracker-board": {
        "latest-cut": "Последний: {cutNumber}",
        "start-cut": "Начало: {cutNumber}",
        "more-info": "подробнее",
        "calculated-from-latest-chainage": "Рассчитано из последнего пикета и введённых пройденных метров.",
        "cut-number": "ВРУБ №",
        "last-survey": "ПОСЛЕДНЯЯ СЪЁМКА",
        "chainage-calc": "ПИКЕТ (расч.)"
    },
    "import-blast-packets": {
        validate: "Проверить",
        "there-are-one-or-more-issues-with-the-blast-packet-design-please-resolve-before-continuing": "В проекте взрывного пакета есть одна или несколько проблем. Пожалуйста, устраните их перед продолжением",
        "successfully-imported-blast-packets": "Взрывные пакеты успешно импортированы",
        "there-may-have-been-issues-with-your-import": "Возможно, с вашим импортом были проблемы"
    },
    "import-location-rings": {
        validate: "Проверить",
        "there-are-one-or-more-issues-with-the-ring-design-please-resolve-before-continuing": "В проекте веера есть одна или несколько проблем. Пожалуйста, устраните их перед продолжением",
        "successfully-import-rings": "Веера успешно импортированы",
        "import-issues": "Возможно, с вашим импортом были проблемы",
        "ring-order": "Порядок вееров",
        "hole-name": "Название скважины",
        "drill-distance": "Расстояние бурения",
        "charge-distance": "Расстояние зарядки"
    },
    "location-tracker-side-drawer": {
        "archived-term": "Архивированный {term}",
        rings: "Веера",
        "blast-packets": "Взрывные пакеты",
        physicals: "Физические показатели",
        "column-options": "Параметры столбцов",
        information: "Информация",
        planning: "Планирование",
        "shift-sidedrawer": "Боковая панель смены",
        "location-filters": "Фильтры локаций",
        clear: "Очистить",
        "show-archived": "Показать архивированные"
    },
    "slc-tracker-board": {
        "location-ring-assigned-to-blast-packet": "Веер локации {name} назначен взрывному пакету.",
        "blast-packet-has-work": "Для взрывного пакета {name} запланированы и/или записаны работы.",
        "bogging-priority": "Приоритет погрузки",
        "ring-duration": "ПРОДОЛЖИТЕЛЬНОСТЬ ВЕЕРА (дней с последнего взрыва)",
        "avg-ring-tonnes-per-day": "СРЕД. ТОНН ВЕЕРА/ДЕНЬ",
        "current-status": "ТЕКУЩИЙ СТАТУС",
        "based-on-last-entered-actuals-or-fire-task": "На основе последних введённых фактических данных или задачи взрыва",
        "last-ring-drilled": "ПОСЛЕДНИЙ ПРОБУРЕННЫЙ ВЕЕР",
        "last-ring-charged": "ПОСЛЕДНИЙ ЗАРЯЖЕННЫЙ ВЕЕР",
        "last-ring-fired": "ПОСЛЕДНИЙ ВЗОРВАННЫЙ ВЕЕР",
        "days-charged": "ДНЕЙ ЗАРЯЖЕН",
        "next-ring-to-fire": "СЛЕДУЮЩИЙ ВЕЕР ДЛЯ ВЗРЫВА",
        "recovery-ring-detail": "ДЕТАЛИ ВОССТАНОВИТЕЛЬНОГО ВЕЕРА",
        "bogged-to-date": "ПОГРУЖЕНО НА СЕГОДНЯ (т)",
        "still-to-bog": "ОСТАЛОСЬ ПОГРУЗИТЬ (т)",
        "extraction-target": "ЦЕЛЬ ИЗВЛЕЧЕНИЯ (т)",
        "delete-location-ring": "Удалить веер локации",
        "checking-status": "Проверка статуса...",
        "are-you-sure-delete-location-ring": "Вы уверены, что хотите удалить этот веер локации?",
        "deleting-may-lead-to-lost-work": "Его удаление может привести к потере работ и/или удалению связанного взрывного пакета.",
        "confirm-type-name-location-ring": "Чтобы подтвердить удаление, пожалуйста, введите название веера локации ниже.",
        "warning-action-cannot-be-undone": "Внимание: это действие нельзя отменить.",
        "delete-term": "Удалить {term}",
        "are-you-sure-delete-blast-packet": "Вы уверены, что хотите удалить этот взрывной пакет?",
        "confirm-type-name-blast-packet": "Чтобы подтвердить удаление его и всех связанных работ, пожалуйста, введите название взрывного пакета ниже.",
        "failed-to-update-blast-packet": "Не удалось обновить взрывной пакет"
    },
    "stope-levels-list": {
        "stope-term": "Камера {term}",
        "location-has-work-planned": "Для локации {name} запланированы работы.",
        "add-drawpoint": "Добавить выпускную выработку",
        "delete-location": "Удалить локацию",
        "checking-status": "Проверка статуса...",
        "are-you-sure-delete-stope-location": "Вы уверены, что хотите удалить эту локацию камеры?",
        "confirm-type-location-name": "Чтобы подтвердить удаление её и всех связанных работ, пожалуйста, введите название локации ниже.",
        "warning-cannot-be-undone": "Внимание: это действие нельзя отменить."
    },
    "stope-tracker-board": {
        "more-info": "подробнее",
        "bogging-priority": "Приоритет погрузки",
        "calculated-tonnes-tooltip": "Рассчитано из последних измеренных тонн в камере, введённых взорванных тонн и введённых показателей погрузки.",
        "tonnes-in-stope": "Тонн в камере",
        "avg-tonnes-per-day": "СРЕД. ТОНН/ДЕНЬ",
        "bogged-to-date": "ПОГРУЖЕНО НА СЕГОДНЯ (т)",
        "survey-tonnes": "ИЗМЕРЕННЫЕ ТОННЫ",
        "tonnes-avail": "ДОСТУПНО ТОНН"
    },
    "production-front-viewer": {
        "ring-statuses": "Статусы вееров",
        "remove-from-viewer": "Удалить из просмотрщика",
        "add-to-viewer": "Добавить в просмотрщик",
        "lashing-lashed": "Крепление / Закреплено",
        fired: "Взорвано",
        "charging-charged": "Зарядка / Заряжено",
        "drilling-drilled": "Бурение / Пробурено",
        "not-drilled": "Не пробурено",
        "ring-names": "Названия вееров",
        none: "Нет",
        highlight: "Выделить",
        all: "Все",
        choose: "Выбрать",
        "front-progress": "Прогресс фронта",
        drilling: "Бурение",
        "hide-all-ring-names": "Скрыть все названия {term}",
        "show-last-drilled-next-to-fire-ring-names": "Показать названия последнего пробуренного и следующего для взрыва {term}",
        "show-all-ring-names": "Показать все названия {term}",
        "planned-work": "Запланированные работы",
        "work-planned": "Работы запланированы",
        "charge-sleep-expiry": "Срок выдержки заряда",
        "visible-level": "Видимый {term}",
        "show-additional-levels": "Показать дополнительные {term}",
        "planning-view": "Вид планирования",
        "no-planning-overlay": "Нет наложения планирования",
        "show-rings-to-consider-for-progressing-front": "Показать {term} для рассмотрения продвижения фронта",
        "show-valid-rings-to-drill": "Показать допустимые {term} для бурения",
        "start-planning": "Начать планирование"
    },
    "audit-event-viewer": {
        "failed-to-load-data": "Не удалось загрузить данные",
        "hide-detail": "Скрыть детали",
        "show-detail": "Показать детали",
        "audit-event-viewer": "Просмотрщик событий аудита",
        "no-audit-events": "Нет событий аудита",
        "load-more": "Загрузить ещё"
    },
    "change-conflict": {
        "a-change-has-conflicted-with-another-users-changes": "Изменение конфликтует с изменениями другого пользователя.",
        "location-name": "Название локации",
        "updated-by": "Обновлено",
        "change-conflict": "Конфликт изменений",
        "refresh-data": "Обновить данные"
    },
    "communications-equipment-task-card": {
        "task-comments": "Комментарии к задаче"
    },
    "generate-week-key-physical-targets-dialog": {
        "generate-week-targets": "Сгенерировать недельные цели",
        "checking-if-targets-already-exist-for-the-week": "Проверка, существуют ли уже цели для недели...",
        "targets-already-exist-for-the-week": "Цели для недели уже существуют.",
        "do-you-want-to-replace-the-existing-targets": "Хотите заменить существующие цели?",
        "generate-targets-for-the-week": "Сгенерировать цели для недели?",
        "there-are-currently-no-existing-targets-for-this-week": "В настоящее время нет существующих целей для этой недели.",
        generate: "Сгенерировать"
    },
    "main-menu": {
        version: "Версия {version}",
        "change-org-mine": "Сменить Организацию/Рудник",
        administration: "Администрирование",
        help: "Справка",
        "main-menu": "Главное меню",
        logout: "Выход"
    },
    "navigation-menu": {
        "navigation-menu": "Меню навигации",
        "geomoby-logo": "Логотип GeoMoby",
        "shift-board": "Доска смены",
        "data-entry": "Ввод данных",
        "resource-chart": "Диаграмма ресурсов",
        "governance-analytics": "Аналитика управления",
        "daily-analytics": "Ежедневная аналитика",
        "crew-magnet-board": "Магнитная доска бригад",
        "equipment-magnet-board": "Магнитная доска оборудования",
        "shift-supervisor-report": "Отчёт руководителя смены",
        "week-board": "Недельная доска",
        "slc-tracker-board": "Доска отслеживания SLC",
        "stope-tracker-board": "Доска отслеживания камер",
        "development-tracker-board": "Доска отслеживания проходки",
        "production-front-viewer": "Просмотрщик фронта добычи",
        "geomoby-mine-map": "Карта рудника GeoMoby",
        "reporting-targets": "Цели отчётности",
        "daily-report": "Ежедневный отчёт",
        "resources": "Ресурсы",
        "communications": "Коммуникации"
    },
    "no-permission-button": {
        "no-permission": "Нет разрешения",
        "insufficient-permission": "недостаточно прав для выполнения этого действия"
    },
    "print-window": {
        "problems-previewing": "Проблемы с предпросмотром?",
        download: "Скачать",
        refresh: "Обновить",
        "print-window": "Окно печати"
    },
    "shift-owner-menu": {
        "shift-owner": "Владелец смены",
        "publish-shift": "Опубликовать смену",
        handover: "Передача",
        assign: "Назначить",
        "take-ownership": "Принять владение",
        "publish-shift-as-a-snapshot": "Опубликовать смену как снимок",
        "start-handover-meeting": "Начать совещание по передаче смены с другим пользователем",
        "assign-shift-ownership": "Назначить владение сменой другому пользователю",
        "take-shift-ownership": "Принять владение сменой",
        "confirm-publish-shift": "Вы уверены, что хотите опубликовать эту смену и создать базовую линию публикации",
        "no-shift-owner": "Нет владельца смены"
    },
    "terms-and-conditions": {
        "end-user-license-agreement": "Лицензионное соглашение с конечным пользователем",
        "please-read-through-and-accept-the-end-user-license-agreement-to-continue": "Пожалуйста, прочтите и примите лицензионное соглашение с конечным пользователем, чтобы продолжить.",
        "cancel-and-logout": "Отменить и выйти",
        agree: "Согласен",
        "accepted-terms-and-conditions": "Условия приняты"
    },
    "to-do-actions-menu": {
        "add-task": "Добавить задачу",
        "no-tasks": "Нет задач",
        "cannot-add-tasks-whilst-offline": "Невозможно добавлять задачи в автономном режиме."
    },
    "version-check": {
        "your-version-of-ordo-is-out-of-date-please-reload-now": "Ваша версия Ordo устарела. Пожалуйста, перезагрузите сейчас.",
        "new-version": "Новая версия:",
        "your-version": ", ваша версия:",
        "ordo-updated": "Ordo обновлён",
        reload: "Перезагрузить"
    },
    priority: {
        priority: "Приоритет",
        completion: "Завершение",
        "priority-prefix": "Приоритет ",
        "other-prefix": "Другое "
    },
    "communications-page": {
        priorities: "Приоритеты",
        "priority-1": "Приоритет 1",
        "priority-2": "Приоритет 2",
        "priority-3": "Приоритет 3",
        "equipment-in-workshop": "Оборудование в мастерской",
        "equipment-to-workshop-by-eos": "Оборудование в мастерскую к концу смены",
        "weekly-comms": "Недельные коммуникации",
        "shift-comms": "Сменные коммуникации",
        "equipment-and-tasks": "Оборудование и задачи"
    },
    "add-any-staff": {
        "temporarily-add-staff-from-another-crew-into-this-shift": "Временно добавить персонал из другой бригады в эту смену"
    },
    "add-any-staff-to-crew": {
        "permanently-move-staff-from-another-crew-into-this-crew": "Постоянно переместить персонал из другой бригады в эту бригаду",
        "add-staff-to-crew-and-week": "Добавить персонал в бригаду и неделю"
    },
    "board-warnings-dialog": {
        "no-warnings": "Нет предупреждений"
    },
    "bring-forward-dialog": {
        "there-are-no-planned-tasks-to-bring-forward": "Нет запланированных задач для переноса вперёд",
        "this-shift-is-already-fully-planned": "Эта смена уже полностью спланирована",
        "bring-forward": "Перенести вперёд",
        "will-move-from": "переместится с"
    },
    "previous-shift-dialog": {
        "no-tasks": "Нет задач",
        "did-not-fire": "Не взорвано"
    },
    "board-filter-and-sort-drawer-section": {
        clear: "Очистить",
        "show-empty": "Показать пустые {term}"
    },
    "equipment-drawer": {
        "finish-assigning": "Сначала завершите назначение {name}.",
        equipment: "Оборудование",
        "unresourced-tasks": "Необеспеченные ресурсами задачи",
        "hide-unavailable": "Скрыть недоступные {term}",
        "highlight-unresourced-tasks": "Выделить необеспеченные ресурсами задачи"
    },
    "event-logs": {
        "event-log": "Журнал событий",
        "event-logs": "Журналы событий"
    },
    "shift-side-drawer": {
        baselines: "Базовые линии",
        "event-logs": "Журналы событий",
        meetings: "Совещания",
        "shift-handover-meeting": "Совещание по передаче смены",
        "shift-handover": "Передача смены",
        "shift-deployment-meeting": "Совещание по развёртыванию смены",
        "shift-deployment": "Развёртывание смены",
        "filters-and-groups": "Фильтры и группы",
        filters: "Фильтры",
        grouping: "Группировка",
        columns: "Столбцы",
        groupings: "Группировки",
        "shift-sidedrawer": "Боковая панель смены"
    },
    "equipment-availability-bar": {
        unavailable: "Недоступно"
    },
    "resource-chart": {
        "primary-equipment-utilisation": "Процент использования основного {term} в этой смене",
        "secondary-equipment-utilisation": "Процент использования вспомогательного {term} в этой смене",
        "support-equipment-utilisation": "Процент использования поддерживающего {term} в этой смене",
        "resources-chart": "Диаграмма ресурсов",
        "resource-utilisation": "Использование ресурсов",
        "percentage-utilisation-of-crew-members-in-shift": "Процент использования членов бригады в этой смене"
    },
    "location-tasks-card": {
        "no-resource-tasks": "Нет задач {resource}. Назначьте напрямую на задачи.",
        "assign-to-all-resource-tasks": "Назначить на все задачи {resource}.",
        no: "Нет {term}",
        commentary: "Комментарии",
        "add-hazard": "Добавить опасность",
        "assign-to-all-term": "Назначить на все {term}",
        "cannot-auto-assign-based-on-role": "Невозможно автоматически назначить на основе роли. Назначьте напрямую на {term}."
    },
    baselines: {
        "hide-baseline": "Скрыть базовую линию",
        baselines: "Базовые линии",
        "enter-actuals": "Ввести фактические данные"
    },
    "supervisor-printer": {
        print: "Печать",
        "print-supervisor-report": "Печать отчёта руководителя"
    },
    "condition-monitoring": {
        "condition-monitoring": "Мониторинг состояния",
        location: "Локация",
        time: "Время",
        activity: "Деятельность",
        action: "Действие"
    },
    "delays-and-down-times": {
        "delays-and-downtime": "Задержки и простои",
        issue: "Проблема",
        hours: "Часы"
    },
    "miscellaneous-tasks": {
        "miscellaneous-tasks": "Прочие задачи",
        location: "Локация",
        task: "Задача",
        physicals: "Физические показатели",
        unit: "Единица",
        comments: "Комментарии"
    },
    "planned-equipment": {
        operator: "Оператор",
        level: "Горизонт",
        location: "Локация",
        task: "Задача",
        details: "Детали"
    },
    "shift-manning": {
        "shift-manning": "Укомплектование смены",
        "safe-stops": "Безопасные остановки",
        hrs: "Ч",
        total: "ИТОГО:"
    },
    "supervisor-equipment-downtime-tab": {
        "add-term-downtime": "Добавить простой {term}",
        downtime: "Простой",
        "add-downtime": "Добавить простой {term}",
        select: "Выбрать {term}",
        "select-reason": "Выберите причину",
        "minutes-downtime": "Минут простоя",
        comment: "Комментарий",
        "add-equipment-downtime": "Добавить {term}",
        "must-be-at-least-15-minutes": "Должно быть не менее 15 минут"
    },
    "supervisor-staff-and-equipment-tab": {
        "no-more-than-hours": "Не более {hours} часов.",
        "safe-stops": "Безопасные остановки",
        "shift-manning": "Укомплектование смены",
        prestart: "Предпусковой осмотр",
        hazards: "Опасности",
        hours: "Часы",
        "hours-worked": "Отработанные часы"
    },
    "variance-to-plan": {
        "variance-to-plan": "Отклонение (от плана)",
        area: "Область",
        priority: "Приоритет",
        comments: "Комментарии",
        unavailable: "Недоступно"
    },
    "in-place-task-quantity-update": {
        quantity: "Количество:",
        "chainage-label": "Пикет:",
        start: "Начало",
        end: "Конец",
        confirm: "Подтвердить"
    },
    "key-physical-targets": {
        "week-level-targets": "Цели уровня недели: Неделя, начинающаяся {weekStart}",
        "key-physical-targets": "Цели ключевых физических показателей",
        "project-level-targets": "Цели уровня проекта",
        "import-targets": "Импорт целей",
        "key-physical-targets-term": "Цели {term}",
        "month-level-targets": "Цели уровня месяца",
        "no-weekly-targets": "Нет недельных целей. Хотите их сгенерировать?",
        "generate-targets": "Сгенерировать цели",
        "metres-advanced": "Пройденные метры",
        "tonnes-bogged": "Погруженные тонны",
        "tonnes-fired": "Взорванные тонны"
    },
    "manual-planning-drawer": {
        planning: "Планирование",
        "finish-planning-current-task": "Завершить планирование текущей задачи...",
        loading: "Загрузка...",
        "choose-planning-type": "Выберите тип планирования",
        "no-cycles": "Нет циклов",
        "no-tasks": "Нет задач"
    },
    "planning-drawer": {
        "remove-name": "Удалить {name}",
        planning: "Планирование",
        "show-suggested-tasks": "Показать предложенные задачи",
        "show-all-tasks": "Показать все задачи",
        "show-all-blast-packet-tasks": "Показать все задачи взрывного пакета",
        "finish-planning-current-task": "Завершить планирование текущей задачи...",
        loading: "Загрузка...",
        "only-show-suggested-ring-tasks": "Показывать только предложенные задачи вееров",
        "show-all-ring-tasks": "Показать все задачи вееров",
        "only-show-suggested-blast-packet-tasks": "Показывать только предложенные задачи взрывного пакета (скрывает задачи, если не все веера заряжены)",
        "no-rings": "Нет вееров"
    },
    screen: {
        bog: "Погрузка",
        drill: "Бурение"
    },
    account: {
        "back-to-board": "Назад к доске",
        "my-account": "Моя учётная запись",
        "change-password": "Сменить пароль",
        "current-password": "Текущий пароль",
        "new-password": "Новый пароль",
        "new-password-again": "Новый пароль ещё раз",
        change: "Сменить"
    },
    admin: {
        "back-to-board": "Назад к доске",
        "super-admin": "Суперадминистратор",
        "fix-users": "ИСПРАВИТЬ ПОЛЬЗОВАТЕЛЕЙ"
    },
    callback: {
        "logging-you-in": "Выполняется вход...",
        "logging-you-in-error": "Произошла ошибка при входе, пожалуйста, попробуйте снова"
    },
    error404: {
        "page-not-found": "Страница не найдена"
    },
    home: {
        begin: "Начать",
        logout: "Выход",
        login: "Вход"
    },
    login: {
        "taking-you-to-the-login-screen": "Перенаправление на экран входа..."
    },
    logout: {
        "logging-you-out": "Выполняется выход..."
    },
    "import-reporting-months-dialog": {
        line: "Строка {number}",
        "month-template": "Месяц {month}",
        "import-reporting-months": "Импорт отчётных месяцев",
        validate: "Проверить",
        "import-file-details": "Детали файла импорта",
        "to-aid-in-importing": "Чтобы облегчить импорт отчётных месяцев, пожалуйста, скачайте шаблон.",
        "each-line-corresponds": "Каждая строка в файле импорта соответствует одному отчётному месяцу.",
        year: "Год",
        "year-description": ": Год отчётного месяца.",
        month: "Месяц",
        "month-description": ": Номер месяца (1-12).",
        "start-date": "Дата начала",
        "start-date-description": ": Дата начала отчётного месяца в формате ГГГГ-ММ-ДД.",
        "end-date": "Дата окончания",
        "end-date-description": ": Дата окончания отчётного месяца в формате ГГГГ-ММ-ДД.",
        "import-issues": "В вашем импорте есть одна или несколько проблем. Пожалуйста, устраните их перед продолжением",
        "import-warning": "Возможно, с вашим импортом были проблемы",
        "unknown-error": "Неизвестная ошибка"
    },
    "production-front-overlay-card": {
        "overlay-name": "Название наложения"
    },
    staff: {
        "active-term": "Активный {term}",
        "archived-term": "Архивированный {term}",
        "cannot-import-no-staff-roles-available": "Невозможно импортировать: нет доступных ролей персонала.",
        "archiving-removes-from-crew": "Архивирование сотрудника удаляет его из бригады, но не влияет на исторические назначения.",
        "archive-staff-member": "Архивировать сотрудника?",
        "restoring-not-add-to-crew": "Восстановление сотрудника не вернёт его обратно в бригаду.",
        "restore-archived-staff-member": "Восстановить архивированного сотрудника?"
    },
    "stope-tarp-history-dialog": {
        "changed-at": "Изменено в",
        "changed-by": "Изменено",
        comments: "Комментарии"
    },
    "report-viewer": {
        "refreshes-exhausted": "Обновления исчерпаны. Обновления сбросятся: {resetAt}",
        "last-refreshed": "Последнее обновление {dateTime}",
        "refreshes-will-reset-at": "Обновления сбросятся в {dateTime}",
        refresh: "Обновить",
        "no-permission-to-refresh-reports": "У вас нет разрешения на обновление отчётов.",
        "last-refresh-running-longer-than-expected": "Последнее обновление выполняется дольше ожидаемого...",
        "refreshes-nearing-limit": "Обновления приближаются к пределу",
        "fewer-than-2-refreshes-remaining": "У вас осталось менее 2 обновлений.",
        "are-you-sure-wish-to-refresh": "Вы уверены, что хотите обновить?",
        "refresh-queued": "Обновление поставлено в очередь"
    },
    "offline-button": {
        "no-connection": "Нет соединения",
        "internet-connection-not-active": "Ваше интернет-соединение в настоящее время неактивно. Если это временно, подождите немного, и эта страница снова станет доступной."
    },
    "shift-inspections": {
        attachments: "Вложения",
        "view-attachments": "Просмотреть вложения",
        "reported-by": "Сообщено",
        "reported-at": "Сообщено в"
    },
    "copy-shift-crew-assignments-dialog": {
        crews: "Бригады: {crews}",
        "this-will-result-in-the-following-changes": "Это приведёт к следующим изменениям:",
        copy: "Копировать"
    },
    "import-week-plan-dialog": {
        "manual-cycle-name": "Ручной цикл - {name}",
        "adhoc-cycle-name": "Разовый цикл - {name}",
        "adhoc-task-name": "Разовая задача - {name}",
        line: "Строка {number}",
        "import-plan": "Импортировать план",
        validate: "Проверить",
        "import-file-details": "Детали файла импорта",
        "help-intro": "Чтобы облегчить импорт плана, пожалуйста, скачайте шаблон.",
        "help-each-line": "Каждая строка в файле импорта соответствует либо одной задаче, либо целому циклу работ.",
        "col-location": "Локация",
        "col-location-desc": ": Название локации, в которой планируются работы.",
        "col-priority": "Приоритет",
        "col-priority-desc": ": Приоритет планирования, назначаемый этой локации на этой неделе. Должен быть неотрицательным целым числом.",
        "col-target-cycles": "Целевые циклы (необязательно)",
        "col-target-cycles-desc": ": Количество циклов, которые планируется завершить на этой неделе. Должно быть неотрицательным целым числом.",
        "col-target-start-shift": "Целевая смена начала",
        "col-target-start-shift-desc": ": Название смены, в которой должны начаться работы. Должно быть в формате \"[День недели] [Название смены]\". Напр. \"Пн Ночь\"",
        "col-start-time": "Время начала (необязательно)",
        "col-start-time-desc-1": ": Время суток, в которое должны начаться работы. Должно попадать в",
        "col-start-time-desc-2": "и быть в 24-часовом формате. Если не указано, по умолчанию устанавливается начало смены.",
        "col-import-type": "Тип импорта",
        "col-import-type-desc-1": ": Тип импортируемых работ. Должен быть \"Задача\", \"Цикл\" или \"Разовая\". \"Задача\" используется для импорта отдельных задач или построения ручных циклов работ (вместе с",
        "col-import-type-desc-2": ". \"Цикл\" используется для импорта предопределённых циклов работ. \"Разовая\" используется для импорта разовых задач, таких как Обслуживание или Техобслуживание.",
        "col-cycle-id": "Id цикла",
        "col-cycle-name": "Название цикла",
        and: "и",
        "col-duration": "Продолжительность (требуется для импорта разовых задач и задач)",
        "col-duration-desc": ": Продолжительность запланированных работ с шагом 15 минут. Будет округлена вниз, если не кратна 15 минутам.",
        "col-task-name": "Название задачи (требуется для импорта разовых задач и задач)",
        "col-task-name-desc": ": Название предопределённого типа задачи, к которому относятся работы.",
        "col-cycle-name-full": "Название цикла (требуется для импорта циклов и разовых циклов)",
        "col-cycle-name-desc": ": Для импорта циклов это название предопределённого цикла работ для планирования. Также должно быть указано при планировании ручного цикла (включая разовые циклы), в этом случае это может быть либо название предопределённого цикла работ для связи с ручным циклом, либо совершенно новое название. Должно быть не более 50 символов.",
        "col-cycle-name-abbr": "Аббревиатура названия цикла (необязательно)",
        "col-cycle-name-abbr-desc": ": При планировании ручных циклов работ предоставляет аббревиатуру названия цикла для отображения в небольших пространствах. Должно быть не более 20 символов.",
        "col-cycle-id-optional": "Id цикла (необязательно)",
        "col-cycle-id-desc": ": Используется для группировки импортов задач в файле как единого ручного цикла. Также может использоваться для добавления новых задач в существующие ручные циклы с предыдущей недели.",
        "col-cycle-fg-colour": "Цвет текста цикла (необязательно)",
        "col-cycle-fg-colour-desc": ": При указании ручного цикла (включая разовые циклы) задаёт цвет текста цикла в интерфейсе. Должен быть допустимым цветом CSS.",
        "col-cycle-bg-colour": "Цвет фона цикла (необязательно)",
        "col-cycle-bg-colour-desc": ": При указании ручного цикла (включая разовые циклы) задаёт цвет цикла в интерфейсе. Должен быть допустимым цветом CSS.",
        "col-quantity": "Количество (требуется для задач на основе нормы)",
        "col-quantity-desc": ": Используется для назначения количества импорту задачи. Напр. \"Метры для бурения\".",
        "col-ring-name": "Название веера (необязательно)",
        "col-ring-name-desc": ": Используется для указания того, что задача служит продвижению веера к точке взрыва.",
        "col-blast-packet-name": "Название взрывного пакета (необязательно)",
        "col-blast-packet-name-desc": ": Используется для указания того, что задача служит взрыву или погрузке взрывного пакета.",
        "col-equipment-name": "Название оборудования (необязательно)",
        "col-task-priority": "Приоритет задачи (необязательно)",
        "col-task-priority-desc": ": Используется с импортом разовых задач для назначения приоритета задачи.",
        "col-location-name-override": "Переопределение названия локации (необязательно)",
        "col-location-name-override-desc": ": Используется с импортом разовых задач для переопределения названия локации.",
        "col-task-name-override": "Переопределение названия задачи (необязательно)",
        "col-task-name-override-desc": ": Используется с импортом разовых задач для переопределения названия задачи.",
        "col-description": "Описание (необязательно)",
        "col-description-desc": ": Используется с импортом разовых задач для предоставления описания задачи.",
        "col-consumables": "Расходные материалы (необязательно)",
        "col-consumables-desc": ": Используется с импортом разовых задач для предоставления списка расходных материалов.",
        "equipment-name-label": "Название оборудования:",
        "quantity-label": "Количество:",
        "ring-bp-label": "Веер/ВП:",
        "location-override-label": "Переопределение локации:",
        "task-override-label": "Переопределение задачи:",
        "consumables-label": "Расходные материалы:",
        "effort-minutes-label": "Трудозатраты (минуты):",
        "description-label": "Описание:",
        "issues-with-plan": "В вашем плане есть одна или несколько проблем. Пожалуйста, устраните их перед продолжением",
        "issues-with-import": "Возможно, с вашим импортом были проблемы",
        "unknown-error": "Неизвестная ошибка"
    },
    "week-side-drawer": {
        baselines: "Базовые линии",
        "stop-showing-baseline": "Прекратить показ базовой линии",
        "enable-historic-edit": "Включить историческое редактирование",
        "filters-and-groups": "Фильтры и группы",
        filters: "Фильтры",
        grouping: "Группировка",
        columns: "Столбцы",
        groupings: "Группировки",
        "allow-movement": "Разрешить перемещение",
        "are-you-sure-move-historic-cycles": "Вы уверены, что хотите переместить исторические циклы? Это повлияет на фактические данные! Используйте это только если цикл был ошибочно перемещён в прошлое"
    },
    "auto-board-refresher": {
        "auto-refresh-mode": "Режим автообновления"
    },
    "resource-levelling-hint-menu": {
        "clear-override": "Очистить переопределение",
        "contributing-work": "Способствующие работы",
        "under-resourced-title": "Недостаточно ресурсов",
        "over-resource-target-title": "Превышение целевого ресурса",
        "under-utilised-title": "Недоиспользовано",
        "no-crew-title": "Нет бригады",
        "no-resources-title": "Нет ресурсов",
        "under-resourced-message-1": "Недостаточно часов трудозатрат доступно в этой смене.",
        "under-resourced-message-2": "Попробуйте добавить в смену персонал, способный выполнять этот тип работ, или переместить некоторые задачи в другие смены.",
        "over-resource-target-message-1": "Часы трудозатрат, необходимые для этого типа работ, превышают целевой процент обеспеченности ресурсами.",
        "over-resource-target-message-2": "Если это проблема, попробуйте добавить в смену персонал, способный выполнять этот тип работ, или переместить некоторые задачи в другие смены.",
        "under-utilised-message-1": "Часы трудозатрат ниже процента недоиспользования. Это может означать, что у вас недостаточно задействован персонал.",
        "under-utilised-message-2": "Попробуйте переместить некоторые задачи в эту смену из других смен.",
        "no-crew-message-1": "В этой смене нет назначенной бригады.",
        "no-crew-message-2": "Чтобы увидеть статус обеспеченности ресурсами, назначьте бригаду на смену.",
        "no-resources-message-1": "В этой смене нет доступного персонала, способного выполнять этот тип работ.",
        "no-resources-message-2": "Добавьте персонал в смену или удалите все задачи этого типа из смены.",
        "acceptable-message": "Обеспеченность ресурсами приемлема.",
        "overridden-suffix": " (переопределено)",
        "tooltip-no-crew": "Бригада ещё не назначена.",
        "tooltip-no-resources": "Нет доступных ресурсов для этого типа работ. Требуется {requiredHours} часов.",
        "tooltip-over-resource-target": "Превышение целевого ресурса. Доступно {availableHours} часов{overridden}, требуется {requiredHours} часов.",
        "tooltip-over-resource-availability": "Недостаточно доступных ресурсов этого типа. Доступно {availableHours} часов{overridden}, требуется {requiredHours} часов.",
        "tooltip-under-utilised": "Ресурсы недоиспользуются. Доступно {availableHours} часов{overridden}, требуется {requiredHours} часов.",
        "tooltip-acceptable": "Обеспеченность ресурсами приемлема. Доступно {availableHours} часов{overridden}, требуется {requiredHours} часов."
    },
    "stope-tarp-statuses-list": {
        "last-updated": "Последнее обновление"
    },
    "production-front-visualisation": {
        "error-loading-overlay": "Ошибка загрузки наложения {overlay} для горизонта {level}",
        "front-band-path-start": "M {x1},{y1} L {x2},{y2}",
        "diagram-warnings": "Предупреждения диаграммы"
    },
    "summary-tarp-status": {
        "change-status": "Изменить статус",
        "view-history": "Просмотреть историю"
    },
    "task-information": {
        "shift-plan": "План смены",
        "remaining-actuals": "Оставшиеся фактические данные"
    },
    shift: {
        "show-inactive-term": "Показать неактивные {term}",
        "print-name": "Печать {name}",
        "configure-board": "Настроить доску",
        "quick-actions": "Быстрые действия",
        "frequently-taken-actions": "Часто выполняемые действия",
        "full-activity-names-on-week-board": "Полные названия деятельности на недельной доске",
        "collapse-grouped-adhoc-tasks-alt-y": "Свернуть сгруппированные разовые задачи (Alt+Y)",
        "saving-changes": "Сохранение изменений…",
        language: "Язык",
        "no-next-shift-planned": "Следующая смена не запланирована",
        "24-hour-view": "24-часовой вид",
        "single-shift-view": "Вид одной смены",
        "generate-week-targets": "Сгенерировать недельные цели",
        "manual-planning": "Ручное планирование",
        "print-pack": "Печать пакета",
        "print-screen": "Печать экрана",
        "screenshot-screen": "Снимок экрана",
        "variance-report": "Отчёт об отклонениях",
        "to-force-speed-dial-to-be-included": "Чтобы принудительно включить быстрый набор"
    },
    "equipment-in-location-card": {
        commentary: "Комментарии",
        "mark-as-serviceable": "Отметить как исправный",
        "mark-as-unserviceable": "Отметить как неисправный",
        "mark-as-not-in-workshop-this-shift": "Отметить как не в мастерской в эту смену",
        "mark-as-in-workshop-this-shift": "Отметить как в мастерской в эту смену",
        "in-workshop": "В мастерской",
        "mark-as-not-needed-in-workshop-at-eos": "Отметить как не требующееся в мастерской на конец смены",
        "mark-as-needed-in-workshop-at-eos": "Отметить как требующееся в мастерской на конец смены",
        "needed-in-workshop": "Требуется в мастерской",
        "add-hazard": "Добавить опасность",
        "in-workshop-task": "В МАСТЕРСКОЙ",
        "tram-to-workshop": "ПЕРЕГОН В МАСТЕРСКУЮ"
    },
    "department-selector": {
        "mine-interactions": "Взаимодействия рудника",
        "mine-interactions-board": "Доска взаимодействий рудника"
    },
    "to-do-action-dialog": {
        "completed-at": "Завершено {time}",
        "started-at": "Начато {time}",
        "undo-completion": "Отменить завершение",
        "mark-completed": "Отметить как завершённое",
        "add-comment": "Добавить комментарий",
        "cannot-remove-comments-offline": "Невозможно удалять комментарии в автономном режиме.",
        "remove-comment": "Удалить комментарий",
        "cannot-delete-tasks-offline": "Невозможно удалять задачи в автономном режиме.",
        "delete-task": "Удалить задачу",
        "cannot-edit-tasks-offline": "Невозможно редактировать задачи в автономном режиме.",
        "edit-task": "Редактировать задачу"
    },
    "location-tracker-image-menu": {
        "view-level-map": "Просмотреть карту горизонта"
    },
    "priority-analytics": {
        "analytics-date": "Аналитика, {date}",
        "analytics-week": "Аналитика, неделя {weekNumber} - {weekOf}",
        "shift-planning-not-started-full": "Планирование этой смены не начато. Начните планирование с доски смены",
        "week-planning-not-started-full": "Планирование этой недели не начато. Создайте недельный план перед планированием этой смены"
    },
    "location-task-card": {
        "activity-description": "Описание деятельности"
    },
    "location-survey-metric-details-dialog": {
        "remove-metric": "Удалить {metricName}",
        "confirm-delete-metric": "Хотите продолжить и удалить этот {metricName}?",
        "cannot-delete-whilst-offline": "Невозможно удалить в автономном режиме.",
        "remove-chainage": "Удалить пикет",
        "no-historical-data-available": "Исторические данные недоступны.",
        "load-historical-data": "Загрузить исторические данные",
        "this-action-could-affect-figures": "Это действие может повлиять на рассчитанные показатели и отчётность.",
        "this-action-will-be-audited": "Это действие будет зафиксировано в аудите."
    },
    "shift-crew-selection-menu": {
        "assign-crews": "Назначить бригады"
    },
    logo: {
        "ordo-logo": "Логотип Ordo"
    },
    "standard-attachment-preview": {
        "upload-name": "Загрузить {name}",
        sending: "Отправка...",
        remove: "Удалить",
        "open-for-printing": "Открыть для печати"
    },
    "shift-supervisor-page": {
        "staff-and-term": "Персонал и {term}",
        "no-crew-selected": "Бригада не выбрана",
        "safety-and-incidents": "Безопасность и инциденты",
        "abandon-changes-confirm": "Вы внесли изменения на следующих вкладках, которые будут потеряны, если вы продолжите без их сохранения. Отменить изменения?"
    },
    "location-extended-properties": {
        "possible-values": "Возможные значения",
        "location-property": "Свойство локации"
    },
    "equipment-card": {
        "mark-as-serviceable": "Отметить как исправный",
        "mark-as-unserviceable": "Отметить как неисправный",
        "mark-as-not-in-workshop-this-shift": "Отметить как не в мастерской в эту смену",
        "mark-as-in-workshop-this-shift": "Отметить как в мастерской в эту смену",
        "in-workshop": "В мастерской",
        "mark-as-not-needed-in-workshop-at-eos": "Отметить как не требующееся в мастерской на конец смены",
        "mark-as-needed-in-workshop-at-eos": "Отметить как требующееся в мастерской на конец смены",
        "needed-in-workshop": "Требуется в мастерской",
        "add-hazard": "Добавить опасность",
        "in-workshop-task": "В МАСТЕРСКОЙ",
        "tram-to-workshop": "ПЕРЕГОН В МАСТЕРСКУЮ"
    },
    row: {
        "unknown-action": "Неизвестное действие: {action}",
        "delete-name": "Удалить {name}",
        "are-you-sure-delete-task": "Вы уверены, что хотите удалить эту задачу?"
    },
    "set-location-chainage-dialog": {
        "active-from": "Действует с",
        "update-chainage-title": "Обновить пикет - {name}",
    },
    "set-location-survey-metric-dialog": {
        "active-from": "Действует с"
    },
    "in-place-numeric-editor": {
        confirm: "Подтвердить"
    },
    "location-with-equipment-card": {
        "assign-to-equipment": "Назначить на {equipment}.",
        commentary: "Комментарии",
        "add-hazard": "Добавить опасность",
        "no-term-to-assign-to": "Нет {term} для назначения.",
        "assign-to-all-term": "Назначить на все {term}",
        "multiple-term-allocated": "Назначено несколько {term}. Назначьте напрямую на {term}."
    },
    "column-filter-and-sort-menu": {
        "group-by": "Группировать по {columnName}",
        "sort-and-filter": "Сортировка и фильтрация",
        ungroup: "Разгруппировать",
        "sort-ascending": "Сортировать по возрастанию",
        "sort-descending": "Сортировать по убыванию",
        clear: "Очистить",
        okay: "ОК"
    },
    "operator-completion-sheet": {
        "filter-to-operator": "Фильтровать по оператору.",
        "manual-plods": "Ручные записи выработки"
    },
    "in-place-time-editor": {
        confirm: "Подтвердить"
    },
    "reorder-rings-dialog": {
        "term-reorder-dialog": "Диалог переупорядочивания {term}"
    },
    "ring-configurations": {
        "drill-length-avg": "Длина бурения (сред.)",
        "charge-amount-avg": "Количество заряда (сред.)"
    },
    "week-visualiser": {
        "collision-between": "Коллизия между {taskA} ({startA} - {endA}) и {taskB} ({startB} - {endB}) "
    },
    "reduced-levels": {
        "failed-to-upload-term-map": "Не удалось загрузить карту {term}",
        "failed-to-remove-term-map": "Не удалось удалить карту {term}"
    },
    "location-ring-dialog": {
        "edit-term": "Редактировать {term}",
        "create-term": "Создать {term}",
        "update-term": "Обновить {term}?",
        "ring-belongs-to-blast-packet": "Этот {ring} принадлежит {blastPacket}. Хотите также обновить {blastPacket}?"
    },
    confirm: {
        "delete-resource": "Удалить {resourceType}",
        "confirm-delete-resource": "Вы уверены, что хотите удалить этот {resourceType}?"
    },
    "location-progress": {
        "total-pips-exceed-max": "Общее количество меток не должно превышать maxSegments."
    },
    "week-task-contents": {
        "cut-number-text": "Вруб №{cutNumber} : {text}"
    },
    "data-table-priority-editor": {
        "update-name": "Обновить {name}"
    },
    "data-table-property-editor": {
        "update-name": "Обновить {name}"
    },
    "data-table-select-editor": {
        "update-text": "Обновить {text}"
    }
};

export default ru;
